/*
 * @Copyright 2026. Institute for Future Intelligence, Inc.
 *
 * AUTO-GENERATED by scripts/zeolite-cifs/expand-and-generate.mjs from
 * IZA-SC asymmetric-unit CIFs. Do not edit by hand — re-run the script.
 */

import { CrystalState } from '../types.ts';

// All-silica chabazite (CHA framework, SSZ-13 endmember). Small-pore
// 8-ring zeolite (3.8 Å windows) — workhorse of automotive SCR
// catalysis (Cu-SSZ-13). Coordinates expanded from the IZA-SC
// asymmetric-unit CIF (https://www.iza-structure.org/databases/),
// optimized via DLS76 for pure SiO2. R-3m hexagonal setting.
// BKS force field applies automatically (composition key 'O,Si').
export const CHABAZITE: CrystalState = {
  name: 'Chabazite',
  lattice: { a: 13.675, b: 13.675, c: 14.767, alpha: 90, beta: 90, gamma: 120 },
  spaceGroup: 'R -3 m',
  basis: [
    { element: 'Si', fx: 0.9997, fy: 0.2264, fz: 0.1051, label: 'Si1' },
    { element: 'Si', fx: 0.66637, fy: 0.55973, fz: 0.43843, label: 'Si2' },
    { element: 'Si', fx: 0.33303, fy: 0.89307, fz: 0.77177, label: 'Si3' },
    { element: 'Si', fx: 0.7736, fy: 0.7733, fz: 0.1051, label: 'Si4' },
    { element: 'Si', fx: 0.44027, fy: 0.10663, fz: 0.43843, label: 'Si5' },
    { element: 'Si', fx: 0.10693, fy: 0.43997, fz: 0.77177, label: 'Si6' },
    { element: 'Si', fx: 0.2267, fy: 0.0003, fz: 0.1051, label: 'Si7' },
    { element: 'Si', fx: 0.89337, fy: 0.33363, fz: 0.43843, label: 'Si8' },
    { element: 'Si', fx: 0.56003, fy: 0.66697, fz: 0.77177, label: 'Si9' },
    { element: 'Si', fx: 0.7736, fy: 0.0003, fz: 0.1051, label: 'Si10' },
    { element: 'Si', fx: 0.44027, fy: 0.33363, fz: 0.43843, label: 'Si11' },
    { element: 'Si', fx: 0.10693, fy: 0.66697, fz: 0.77177, label: 'Si12' },
    { element: 'Si', fx: 0.2267, fy: 0.2264, fz: 0.1051, label: 'Si13' },
    { element: 'Si', fx: 0.89337, fy: 0.55973, fz: 0.43843, label: 'Si14' },
    { element: 'Si', fx: 0.56003, fy: 0.89307, fz: 0.77177, label: 'Si15' },
    { element: 'Si', fx: 0.9997, fy: 0.7733, fz: 0.1051, label: 'Si16' },
    { element: 'Si', fx: 0.66637, fy: 0.10663, fz: 0.43843, label: 'Si17' },
    { element: 'Si', fx: 0.33303, fy: 0.43997, fz: 0.77177, label: 'Si18' },
    { element: 'Si', fx: 0.0003, fy: 0.7736, fz: 0.8949, label: 'Si19' },
    { element: 'Si', fx: 0.66697, fy: 0.10693, fz: 0.22823, label: 'Si20' },
    { element: 'Si', fx: 0.33363, fy: 0.44027, fz: 0.56157, label: 'Si21' },
    { element: 'Si', fx: 0.2264, fy: 0.2267, fz: 0.8949, label: 'Si22' },
    { element: 'Si', fx: 0.89307, fy: 0.56003, fz: 0.22823, label: 'Si23' },
    { element: 'Si', fx: 0.55973, fy: 0.89337, fz: 0.56157, label: 'Si24' },
    { element: 'Si', fx: 0.7733, fy: 0.9997, fz: 0.8949, label: 'Si25' },
    { element: 'Si', fx: 0.43997, fy: 0.33303, fz: 0.22823, label: 'Si26' },
    { element: 'Si', fx: 0.10663, fy: 0.66637, fz: 0.56157, label: 'Si27' },
    { element: 'Si', fx: 0.2264, fy: 0.9997, fz: 0.8949, label: 'Si28' },
    { element: 'Si', fx: 0.89307, fy: 0.33303, fz: 0.22823, label: 'Si29' },
    { element: 'Si', fx: 0.55973, fy: 0.66637, fz: 0.56157, label: 'Si30' },
    { element: 'Si', fx: 0.7733, fy: 0.7736, fz: 0.8949, label: 'Si31' },
    { element: 'Si', fx: 0.43997, fy: 0.10693, fz: 0.22823, label: 'Si32' },
    { element: 'Si', fx: 0.10663, fy: 0.44027, fz: 0.56157, label: 'Si33' },
    { element: 'Si', fx: 0.0003, fy: 0.2267, fz: 0.8949, label: 'Si34' },
    { element: 'Si', fx: 0.66697, fy: 0.56003, fz: 0.22823, label: 'Si35' },
    { element: 'Si', fx: 0.33363, fy: 0.89337, fz: 0.56157, label: 'Si36' },
    { element: 'O', fx: 0.902, fy: 0.098, fz: 0.1227, label: 'O1' },
    { element: 'O', fx: 0.56867, fy: 0.43133, fz: 0.45603, label: 'O2' },
    { element: 'O', fx: 0.23533, fy: 0.76467, fz: 0.78937, label: 'O3' },
    { element: 'O', fx: 0.902, fy: 0.804, fz: 0.1227, label: 'O4' },
    { element: 'O', fx: 0.56867, fy: 0.13733, fz: 0.45603, label: 'O5' },
    { element: 'O', fx: 0.23533, fy: 0.47067, fz: 0.78937, label: 'O6' },
    { element: 'O', fx: 0.196, fy: 0.098, fz: 0.1227, label: 'O7' },
    { element: 'O', fx: 0.86267, fy: 0.43133, fz: 0.45603, label: 'O8' },
    { element: 'O', fx: 0.52933, fy: 0.76467, fz: 0.78937, label: 'O9' },
    { element: 'O', fx: 0.098, fy: 0.902, fz: 0.8773, label: 'O10' },
    { element: 'O', fx: 0.76467, fy: 0.23533, fz: 0.21063, label: 'O11' },
    { element: 'O', fx: 0.43133, fy: 0.56867, fz: 0.54397, label: 'O12' },
    { element: 'O', fx: 0.098, fy: 0.196, fz: 0.8773, label: 'O13' },
    { element: 'O', fx: 0.76467, fy: 0.52933, fz: 0.21063, label: 'O14' },
    { element: 'O', fx: 0.43133, fy: 0.86267, fz: 0.54397, label: 'O15' },
    { element: 'O', fx: 0.804, fy: 0.902, fz: 0.8773, label: 'O16' },
    { element: 'O', fx: 0.47067, fy: 0.23533, fz: 0.21063, label: 'O17' },
    { element: 'O', fx: 0.13733, fy: 0.56867, fz: 0.54397, label: 'O18' },
    { element: 'O', fx: 0.9767, fy: 0.3101, fz: 0.1667, label: 'O19' },
    { element: 'O', fx: 0.64337, fy: 0.64343, fz: 0.50003, label: 'O20' },
    { element: 'O', fx: 0.31003, fy: 0.97677, fz: 0.83337, label: 'O21' },
    { element: 'O', fx: 0.6899, fy: 0.6666, fz: 0.1667, label: 'O22' },
    { element: 'O', fx: 0.35657, fy: 0.99993, fz: 0.50003, label: 'O23' },
    { element: 'O', fx: 0.02323, fy: 0.33327, fz: 0.83337, label: 'O24' },
    { element: 'O', fx: 0.3334, fy: 0.0233, fz: 0.1667, label: 'O25' },
    { element: 'O', fx: 0.00007, fy: 0.35663, fz: 0.50003, label: 'O26' },
    { element: 'O', fx: 0.66673, fy: 0.68997, fz: 0.83337, label: 'O27' },
    { element: 'O', fx: 0.6899, fy: 0.0233, fz: 0.1667, label: 'O28' },
    { element: 'O', fx: 0.35657, fy: 0.35663, fz: 0.50003, label: 'O29' },
    { element: 'O', fx: 0.02323, fy: 0.68997, fz: 0.83337, label: 'O30' },
    { element: 'O', fx: 0.3334, fy: 0.3101, fz: 0.1667, label: 'O31' },
    { element: 'O', fx: 0.00007, fy: 0.64343, fz: 0.50003, label: 'O32' },
    { element: 'O', fx: 0.66673, fy: 0.97677, fz: 0.83337, label: 'O33' },
    { element: 'O', fx: 0.9767, fy: 0.6666, fz: 0.1667, label: 'O34' },
    { element: 'O', fx: 0.64337, fy: 0.99993, fz: 0.50003, label: 'O35' },
    { element: 'O', fx: 0.31003, fy: 0.33327, fz: 0.83337, label: 'O36' },
    { element: 'O', fx: 0.1203, fy: 0.2405, fz: 0.1315, label: 'O37' },
    { element: 'O', fx: 0.78697, fy: 0.57383, fz: 0.46483, label: 'O38' },
    { element: 'O', fx: 0.45363, fy: 0.90717, fz: 0.79817, label: 'O39' },
    { element: 'O', fx: 0.7595, fy: 0.8798, fz: 0.1315, label: 'O40' },
    { element: 'O', fx: 0.42617, fy: 0.21313, fz: 0.46483, label: 'O41' },
    { element: 'O', fx: 0.09283, fy: 0.54647, fz: 0.79817, label: 'O42' },
    { element: 'O', fx: 0.1202, fy: 0.8797, fz: 0.1315, label: 'O43' },
    { element: 'O', fx: 0.78687, fy: 0.21303, fz: 0.46483, label: 'O44' },
    { element: 'O', fx: 0.45353, fy: 0.54637, fz: 0.79817, label: 'O45' },
    { element: 'O', fx: 0.8797, fy: 0.7595, fz: 0.8685, label: 'O46' },
    { element: 'O', fx: 0.54637, fy: 0.09283, fz: 0.20183, label: 'O47' },
    { element: 'O', fx: 0.21303, fy: 0.42617, fz: 0.53517, label: 'O48' },
    { element: 'O', fx: 0.2405, fy: 0.1202, fz: 0.8685, label: 'O49' },
    { element: 'O', fx: 0.90717, fy: 0.45353, fz: 0.20183, label: 'O50' },
    { element: 'O', fx: 0.57383, fy: 0.78687, fz: 0.53517, label: 'O51' },
    { element: 'O', fx: 0.8798, fy: 0.1203, fz: 0.8685, label: 'O52' },
    { element: 'O', fx: 0.54647, fy: 0.45363, fz: 0.20183, label: 'O53' },
    { element: 'O', fx: 0.21313, fy: 0.78697, fz: 0.53517, label: 'O54' },
    { element: 'O', fx: 0, fy: 0.2577, fz: 0, label: 'O55' },
    { element: 'O', fx: 0.66667, fy: 0.59103, fz: 0.33333, label: 'O56' },
    { element: 'O', fx: 0.33333, fy: 0.92437, fz: 0.66667, label: 'O57' },
    { element: 'O', fx: 0.7423, fy: 0.7423, fz: 0, label: 'O58' },
    { element: 'O', fx: 0.40897, fy: 0.07563, fz: 0.33333, label: 'O59' },
    { element: 'O', fx: 0.07563, fy: 0.40897, fz: 0.66667, label: 'O60' },
    { element: 'O', fx: 0.2577, fy: 0, fz: 0, label: 'O61' },
    { element: 'O', fx: 0.92437, fy: 0.33333, fz: 0.33333, label: 'O62' },
    { element: 'O', fx: 0.59103, fy: 0.66667, fz: 0.66667, label: 'O63' },
    { element: 'O', fx: 0.7423, fy: 0, fz: 0, label: 'O64' },
    { element: 'O', fx: 0.40897, fy: 0.33333, fz: 0.33333, label: 'O65' },
    { element: 'O', fx: 0.07563, fy: 0.66667, fz: 0.66667, label: 'O66' },
    { element: 'O', fx: 0.2577, fy: 0.2577, fz: 0, label: 'O67' },
    { element: 'O', fx: 0.92437, fy: 0.59103, fz: 0.33333, label: 'O68' },
    { element: 'O', fx: 0.59103, fy: 0.92437, fz: 0.66667, label: 'O69' },
    { element: 'O', fx: 0, fy: 0.7423, fz: 0, label: 'O70' },
    { element: 'O', fx: 0.66667, fy: 0.07563, fz: 0.33333, label: 'O71' },
    { element: 'O', fx: 0.33333, fy: 0.40897, fz: 0.66667, label: 'O72' },
  ],
};

// All-silica mordenite (MOR framework). One-dimensional 12-ring main
// channel (7.0 × 6.5 Å); important in n-paraffin hydroisomerization
// and acid catalysis. Coordinates from IZA-SC CIF (DLS76 idealized,
// pure SiO2). Cmcm orthorhombic.
export const MORDENITE: CrystalState = {
  name: 'Mordenite',
  lattice: { a: 18.256, b: 20.534, c: 7.542, alpha: 90, beta: 90, gamma: 90 },
  spaceGroup: 'C m c m',
  basis: [
    { element: 'Si', fx: 0.3057, fy: 0.0736, fz: 0.0435, label: 'Si1' },
    { element: 'Si', fx: 0.8057, fy: 0.5736, fz: 0.0435, label: 'Si2' },
    { element: 'Si', fx: 0.6943, fy: 0.0736, fz: 0.0435, label: 'Si3' },
    { element: 'Si', fx: 0.1943, fy: 0.5736, fz: 0.0435, label: 'Si4' },
    { element: 'Si', fx: 0.3057, fy: 0.9264, fz: 0.5435, label: 'Si5' },
    { element: 'Si', fx: 0.8057, fy: 0.4264, fz: 0.5435, label: 'Si6' },
    { element: 'Si', fx: 0.6943, fy: 0.9264, fz: 0.5435, label: 'Si7' },
    { element: 'Si', fx: 0.1943, fy: 0.4264, fz: 0.5435, label: 'Si8' },
    { element: 'Si', fx: 0.6943, fy: 0.9264, fz: 0.9565, label: 'Si9' },
    { element: 'Si', fx: 0.1943, fy: 0.4264, fz: 0.9565, label: 'Si10' },
    { element: 'Si', fx: 0.3057, fy: 0.9264, fz: 0.9565, label: 'Si11' },
    { element: 'Si', fx: 0.8057, fy: 0.4264, fz: 0.9565, label: 'Si12' },
    { element: 'Si', fx: 0.6943, fy: 0.0736, fz: 0.4565, label: 'Si13' },
    { element: 'Si', fx: 0.1943, fy: 0.5736, fz: 0.4565, label: 'Si14' },
    { element: 'Si', fx: 0.3057, fy: 0.0736, fz: 0.4565, label: 'Si15' },
    { element: 'Si', fx: 0.8057, fy: 0.5736, fz: 0.4565, label: 'Si16' },
    { element: 'Si', fx: 0.3028, fy: 0.3106, fz: 0.0437, label: 'Si17' },
    { element: 'Si', fx: 0.8028, fy: 0.8106, fz: 0.0437, label: 'Si18' },
    { element: 'Si', fx: 0.6972, fy: 0.3106, fz: 0.0437, label: 'Si19' },
    { element: 'Si', fx: 0.1972, fy: 0.8106, fz: 0.0437, label: 'Si20' },
    { element: 'Si', fx: 0.3028, fy: 0.6894, fz: 0.5437, label: 'Si21' },
    { element: 'Si', fx: 0.8028, fy: 0.1894, fz: 0.5437, label: 'Si22' },
    { element: 'Si', fx: 0.6972, fy: 0.6894, fz: 0.5437, label: 'Si23' },
    { element: 'Si', fx: 0.1972, fy: 0.1894, fz: 0.5437, label: 'Si24' },
    { element: 'Si', fx: 0.6972, fy: 0.6894, fz: 0.9563, label: 'Si25' },
    { element: 'Si', fx: 0.1972, fy: 0.1894, fz: 0.9563, label: 'Si26' },
    { element: 'Si', fx: 0.3028, fy: 0.6894, fz: 0.9563, label: 'Si27' },
    { element: 'Si', fx: 0.8028, fy: 0.1894, fz: 0.9563, label: 'Si28' },
    { element: 'Si', fx: 0.6972, fy: 0.3106, fz: 0.4563, label: 'Si29' },
    { element: 'Si', fx: 0.1972, fy: 0.8106, fz: 0.4563, label: 'Si30' },
    { element: 'Si', fx: 0.3028, fy: 0.3106, fz: 0.4563, label: 'Si31' },
    { element: 'Si', fx: 0.8028, fy: 0.8106, fz: 0.4563, label: 'Si32' },
    { element: 'Si', fx: 0.0848, fy: 0.3791, fz: 0.25, label: 'Si33' },
    { element: 'Si', fx: 0.5848, fy: 0.8791, fz: 0.25, label: 'Si34' },
    { element: 'Si', fx: 0.9152, fy: 0.3791, fz: 0.25, label: 'Si35' },
    { element: 'Si', fx: 0.4152, fy: 0.8791, fz: 0.25, label: 'Si36' },
    { element: 'Si', fx: 0.0848, fy: 0.6209, fz: 0.75, label: 'Si37' },
    { element: 'Si', fx: 0.5848, fy: 0.1209, fz: 0.75, label: 'Si38' },
    { element: 'Si', fx: 0.9152, fy: 0.6209, fz: 0.75, label: 'Si39' },
    { element: 'Si', fx: 0.4152, fy: 0.1209, fz: 0.75, label: 'Si40' },
    { element: 'Si', fx: 0.0848, fy: 0.2227, fz: 0.25, label: 'Si41' },
    { element: 'Si', fx: 0.5848, fy: 0.7227, fz: 0.25, label: 'Si42' },
    { element: 'Si', fx: 0.9152, fy: 0.2227, fz: 0.25, label: 'Si43' },
    { element: 'Si', fx: 0.4152, fy: 0.7227, fz: 0.25, label: 'Si44' },
    { element: 'Si', fx: 0.0848, fy: 0.7773, fz: 0.75, label: 'Si45' },
    { element: 'Si', fx: 0.5848, fy: 0.2773, fz: 0.75, label: 'Si46' },
    { element: 'Si', fx: 0.9152, fy: 0.7773, fz: 0.75, label: 'Si47' },
    { element: 'Si', fx: 0.4152, fy: 0.2773, fz: 0.75, label: 'Si48' },
    { element: 'O', fx: 0.2811, fy: 0, fz: 0, label: 'O1' },
    { element: 'O', fx: 0.7811, fy: 0.5, fz: 0, label: 'O2' },
    { element: 'O', fx: 0.7189, fy: 0, fz: 0, label: 'O3' },
    { element: 'O', fx: 0.2189, fy: 0.5, fz: 0, label: 'O4' },
    { element: 'O', fx: 0.2811, fy: 0, fz: 0.5, label: 'O5' },
    { element: 'O', fx: 0.7811, fy: 0.5, fz: 0.5, label: 'O6' },
    { element: 'O', fx: 0.7189, fy: 0, fz: 0.5, label: 'O7' },
    { element: 'O', fx: 0.2189, fy: 0.5, fz: 0.5, label: 'O8' },
    { element: 'O', fx: 0.3268, fy: 0.0795, fz: 0.25, label: 'O9' },
    { element: 'O', fx: 0.8268, fy: 0.5795, fz: 0.25, label: 'O10' },
    { element: 'O', fx: 0.6732, fy: 0.0795, fz: 0.25, label: 'O11' },
    { element: 'O', fx: 0.1732, fy: 0.5795, fz: 0.25, label: 'O12' },
    { element: 'O', fx: 0.3268, fy: 0.9205, fz: 0.75, label: 'O13' },
    { element: 'O', fx: 0.8268, fy: 0.4205, fz: 0.75, label: 'O14' },
    { element: 'O', fx: 0.6732, fy: 0.9205, fz: 0.75, label: 'O15' },
    { element: 'O', fx: 0.1732, fy: 0.4205, fz: 0.75, label: 'O16' },
    { element: 'O', fx: 0.3757, fy: 0.0924, fz: 0.9243, label: 'O17' },
    { element: 'O', fx: 0.8757, fy: 0.5924, fz: 0.9243, label: 'O18' },
    { element: 'O', fx: 0.6243, fy: 0.0924, fz: 0.9243, label: 'O19' },
    { element: 'O', fx: 0.1243, fy: 0.5924, fz: 0.9243, label: 'O20' },
    { element: 'O', fx: 0.3757, fy: 0.9076, fz: 0.4243, label: 'O21' },
    { element: 'O', fx: 0.8757, fy: 0.4076, fz: 0.4243, label: 'O22' },
    { element: 'O', fx: 0.6243, fy: 0.9076, fz: 0.4243, label: 'O23' },
    { element: 'O', fx: 0.1243, fy: 0.4076, fz: 0.4243, label: 'O24' },
    { element: 'O', fx: 0.6243, fy: 0.9076, fz: 0.0757, label: 'O25' },
    { element: 'O', fx: 0.1243, fy: 0.4076, fz: 0.0757, label: 'O26' },
    { element: 'O', fx: 0.3757, fy: 0.9076, fz: 0.0757, label: 'O27' },
    { element: 'O', fx: 0.8757, fy: 0.4076, fz: 0.0757, label: 'O28' },
    { element: 'O', fx: 0.6243, fy: 0.0924, fz: 0.5757, label: 'O29' },
    { element: 'O', fx: 0.1243, fy: 0.5924, fz: 0.5757, label: 'O30' },
    { element: 'O', fx: 0.3757, fy: 0.0924, fz: 0.5757, label: 'O31' },
    { element: 'O', fx: 0.8757, fy: 0.5924, fz: 0.5757, label: 'O32' },
    { element: 'O', fx: 0.2391, fy: 0.1223, fz: 0.9992, label: 'O33' },
    { element: 'O', fx: 0.7391, fy: 0.6223, fz: 0.9992, label: 'O34' },
    { element: 'O', fx: 0.7609, fy: 0.1223, fz: 0.9992, label: 'O35' },
    { element: 'O', fx: 0.2609, fy: 0.6223, fz: 0.9992, label: 'O36' },
    { element: 'O', fx: 0.2391, fy: 0.8777, fz: 0.4992, label: 'O37' },
    { element: 'O', fx: 0.7391, fy: 0.3777, fz: 0.4992, label: 'O38' },
    { element: 'O', fx: 0.7609, fy: 0.8777, fz: 0.4992, label: 'O39' },
    { element: 'O', fx: 0.2609, fy: 0.3777, fz: 0.4992, label: 'O40' },
    { element: 'O', fx: 0.7609, fy: 0.8777, fz: 0.0008, label: 'O41' },
    { element: 'O', fx: 0.2609, fy: 0.3777, fz: 0.0008, label: 'O42' },
    { element: 'O', fx: 0.2391, fy: 0.8777, fz: 0.0008, label: 'O43' },
    { element: 'O', fx: 0.7391, fy: 0.3777, fz: 0.0008, label: 'O44' },
    { element: 'O', fx: 0.7609, fy: 0.1223, fz: 0.5008, label: 'O45' },
    { element: 'O', fx: 0.2609, fy: 0.6223, fz: 0.5008, label: 'O46' },
    { element: 'O', fx: 0.2391, fy: 0.1223, fz: 0.5008, label: 'O47' },
    { element: 'O', fx: 0.7391, fy: 0.6223, fz: 0.5008, label: 'O48' },
    { element: 'O', fx: 0.3253, fy: 0.3089, fz: 0.25, label: 'O49' },
    { element: 'O', fx: 0.8253, fy: 0.8089, fz: 0.25, label: 'O50' },
    { element: 'O', fx: 0.6747, fy: 0.3089, fz: 0.25, label: 'O51' },
    { element: 'O', fx: 0.1747, fy: 0.8089, fz: 0.25, label: 'O52' },
    { element: 'O', fx: 0.3253, fy: 0.6911, fz: 0.75, label: 'O53' },
    { element: 'O', fx: 0.8253, fy: 0.1911, fz: 0.75, label: 'O54' },
    { element: 'O', fx: 0.6747, fy: 0.6911, fz: 0.75, label: 'O55' },
    { element: 'O', fx: 0.1747, fy: 0.1911, fz: 0.75, label: 'O56' },
    { element: 'O', fx: 0.25, fy: 0.25, fz: 0, label: 'O57' },
    { element: 'O', fx: 0.75, fy: 0.75, fz: 0, label: 'O58' },
    { element: 'O', fx: 0.75, fy: 0.25, fz: 0, label: 'O59' },
    { element: 'O', fx: 0.25, fy: 0.75, fz: 0, label: 'O60' },
    { element: 'O', fx: 0.25, fy: 0.75, fz: 0.5, label: 'O61' },
    { element: 'O', fx: 0.75, fy: 0.25, fz: 0.5, label: 'O62' },
    { element: 'O', fx: 0.75, fy: 0.75, fz: 0.5, label: 'O63' },
    { element: 'O', fx: 0.25, fy: 0.25, fz: 0.5, label: 'O64' },
    { element: 'O', fx: 0.3757, fy: 0.3058, fz: 0.9242, label: 'O65' },
    { element: 'O', fx: 0.8757, fy: 0.8058, fz: 0.9242, label: 'O66' },
    { element: 'O', fx: 0.6243, fy: 0.3058, fz: 0.9242, label: 'O67' },
    { element: 'O', fx: 0.1243, fy: 0.8058, fz: 0.9242, label: 'O68' },
    { element: 'O', fx: 0.3757, fy: 0.6942, fz: 0.4242, label: 'O69' },
    { element: 'O', fx: 0.8757, fy: 0.1942, fz: 0.4242, label: 'O70' },
    { element: 'O', fx: 0.6243, fy: 0.6942, fz: 0.4242, label: 'O71' },
    { element: 'O', fx: 0.1243, fy: 0.1942, fz: 0.4242, label: 'O72' },
    { element: 'O', fx: 0.6243, fy: 0.6942, fz: 0.0758, label: 'O73' },
    { element: 'O', fx: 0.1243, fy: 0.1942, fz: 0.0758, label: 'O74' },
    { element: 'O', fx: 0.3757, fy: 0.6942, fz: 0.0758, label: 'O75' },
    { element: 'O', fx: 0.8757, fy: 0.1942, fz: 0.0758, label: 'O76' },
    { element: 'O', fx: 0.6243, fy: 0.3058, fz: 0.5758, label: 'O77' },
    { element: 'O', fx: 0.1243, fy: 0.8058, fz: 0.5758, label: 'O78' },
    { element: 'O', fx: 0.3757, fy: 0.3058, fz: 0.5758, label: 'O79' },
    { element: 'O', fx: 0.8757, fy: 0.8058, fz: 0.5758, label: 'O80' },
    { element: 'O', fx: 0, fy: 0.4005, fz: 0.25, label: 'O81' },
    { element: 'O', fx: 0.5, fy: 0.9005, fz: 0.25, label: 'O82' },
    { element: 'O', fx: 0, fy: 0.5995, fz: 0.75, label: 'O83' },
    { element: 'O', fx: 0.5, fy: 0.0995, fz: 0.75, label: 'O84' },
    { element: 'O', fx: 0.0906, fy: 0.3009, fz: 0.25, label: 'O85' },
    { element: 'O', fx: 0.5906, fy: 0.8009, fz: 0.25, label: 'O86' },
    { element: 'O', fx: 0.9094, fy: 0.3009, fz: 0.25, label: 'O87' },
    { element: 'O', fx: 0.4094, fy: 0.8009, fz: 0.25, label: 'O88' },
    { element: 'O', fx: 0.0906, fy: 0.6991, fz: 0.75, label: 'O89' },
    { element: 'O', fx: 0.5906, fy: 0.1991, fz: 0.75, label: 'O90' },
    { element: 'O', fx: 0.9094, fy: 0.6991, fz: 0.75, label: 'O91' },
    { element: 'O', fx: 0.4094, fy: 0.1991, fz: 0.75, label: 'O92' },
    { element: 'O', fx: 0, fy: 0.2013, fz: 0.25, label: 'O93' },
    { element: 'O', fx: 0.5, fy: 0.7013, fz: 0.25, label: 'O94' },
    { element: 'O', fx: 0, fy: 0.7987, fz: 0.75, label: 'O95' },
    { element: 'O', fx: 0.5, fy: 0.2987, fz: 0.75, label: 'O96' },
  ],
};

// All-silica faujasite (FAU framework, siliceous Y endmember). The
// most open of the major zeolites — 12-ring windows (7.4 Å), large
// supercages. Workhorse of catalytic cracking (FCC, USY). Fd-3m
// cubic, a = 24.345 Å. Conventional cell has 576 atoms — over the
// 500-atom guideline, so a 1×1×1 lab runs, but slowly. Coordinates
// from IZA-SC CIF (DLS76 idealized, pure SiO2), shifted by (⅛,⅛,⅛):
// IZA writes Fd-3m in origin choice 2 (inversion at the origin), while
// the symmetry table — like the diamond, silicon and cristobalite
// presets — uses origin choice 1, and Fill cell on the unshifted cell
// made 3,712 atoms.
export const FAUJASITE: CrystalState = {
  name: 'Faujasite',
  lattice: { a: 24.345, b: 24.345, c: 24.345, alpha: 90, beta: 90, gamma: 90 },
  spaceGroup: 'F d -3 m',
  basis: [
    { element: 'Si', fx: 0.0719, fy: 0.2501, fz: 0.1614, label: 'Si1' },
    { element: 'Si', fx: 0.0719, fy: 0.7501, fz: 0.6614, label: 'Si2' },
    { element: 'Si', fx: 0.5719, fy: 0.7501, fz: 0.1614, label: 'Si3' },
    { element: 'Si', fx: 0.5719, fy: 0.2501, fz: 0.6614, label: 'Si4' },
    { element: 'Si', fx: 0.1614, fy: 0.0719, fz: 0.2501, label: 'Si5' },
    { element: 'Si', fx: 0.1614, fy: 0.5719, fz: 0.7501, label: 'Si6' },
    { element: 'Si', fx: 0.6614, fy: 0.5719, fz: 0.2501, label: 'Si7' },
    { element: 'Si', fx: 0.6614, fy: 0.0719, fz: 0.7501, label: 'Si8' },
    { element: 'Si', fx: 0.2501, fy: 0.1614, fz: 0.0719, label: 'Si9' },
    { element: 'Si', fx: 0.2501, fy: 0.6614, fz: 0.5719, label: 'Si10' },
    { element: 'Si', fx: 0.7501, fy: 0.6614, fz: 0.0719, label: 'Si11' },
    { element: 'Si', fx: 0.7501, fy: 0.1614, fz: 0.5719, label: 'Si12' },
    { element: 'Si', fx: 0.1781, fy: 0.5001, fz: 0.4114, label: 'Si13' },
    { element: 'Si', fx: 0.1781, fy: 0.0001, fz: 0.9114, label: 'Si14' },
    { element: 'Si', fx: 0.6781, fy: 0.0001, fz: 0.4114, label: 'Si15' },
    { element: 'Si', fx: 0.6781, fy: 0.5001, fz: 0.9114, label: 'Si16' },
    { element: 'Si', fx: 0.0886, fy: 0.3219, fz: 0.5001, label: 'Si17' },
    { element: 'Si', fx: 0.0886, fy: 0.8219, fz: 0.0001, label: 'Si18' },
    { element: 'Si', fx: 0.5886, fy: 0.8219, fz: 0.5001, label: 'Si19' },
    { element: 'Si', fx: 0.5886, fy: 0.3219, fz: 0.0001, label: 'Si20' },
    { element: 'Si', fx: 0.9999, fy: 0.4114, fz: 0.3219, label: 'Si21' },
    { element: 'Si', fx: 0.9999, fy: 0.9114, fz: 0.8219, label: 'Si22' },
    { element: 'Si', fx: 0.4999, fy: 0.9114, fz: 0.3219, label: 'Si23' },
    { element: 'Si', fx: 0.4999, fy: 0.4114, fz: 0.8219, label: 'Si24' },
    { element: 'Si', fx: 0.3219, fy: 0.9999, fz: 0.4114, label: 'Si25' },
    { element: 'Si', fx: 0.3219, fy: 0.4999, fz: 0.9114, label: 'Si26' },
    { element: 'Si', fx: 0.8219, fy: 0.4999, fz: 0.4114, label: 'Si27' },
    { element: 'Si', fx: 0.8219, fy: 0.9999, fz: 0.9114, label: 'Si28' },
    { element: 'Si', fx: 0.4114, fy: 0.1781, fz: 0.5001, label: 'Si29' },
    { element: 'Si', fx: 0.4114, fy: 0.6781, fz: 0.0001, label: 'Si30' },
    { element: 'Si', fx: 0.9114, fy: 0.6781, fz: 0.5001, label: 'Si31' },
    { element: 'Si', fx: 0.9114, fy: 0.1781, fz: 0.0001, label: 'Si32' },
    { element: 'Si', fx: 0.5001, fy: 0.0886, fz: 0.3219, label: 'Si33' },
    { element: 'Si', fx: 0.5001, fy: 0.5886, fz: 0.8219, label: 'Si34' },
    { element: 'Si', fx: 0.0001, fy: 0.5886, fz: 0.3219, label: 'Si35' },
    { element: 'Si', fx: 0.0001, fy: 0.0886, fz: 0.8219, label: 'Si36' },
    { element: 'Si', fx: 0.4281, fy: 0.7499, fz: 0.6614, label: 'Si37' },
    { element: 'Si', fx: 0.4281, fy: 0.2499, fz: 0.1614, label: 'Si38' },
    { element: 'Si', fx: 0.9281, fy: 0.2499, fz: 0.6614, label: 'Si39' },
    { element: 'Si', fx: 0.9281, fy: 0.7499, fz: 0.1614, label: 'Si40' },
    { element: 'Si', fx: 0.3386, fy: 0.9281, fz: 0.7501, label: 'Si41' },
    { element: 'Si', fx: 0.3386, fy: 0.4281, fz: 0.2501, label: 'Si42' },
    { element: 'Si', fx: 0.8386, fy: 0.4281, fz: 0.7501, label: 'Si43' },
    { element: 'Si', fx: 0.8386, fy: 0.9281, fz: 0.2501, label: 'Si44' },
    { element: 'Si', fx: 0.2499, fy: 0.8386, fz: 0.5719, label: 'Si45' },
    { element: 'Si', fx: 0.2499, fy: 0.3386, fz: 0.0719, label: 'Si46' },
    { element: 'Si', fx: 0.7499, fy: 0.3386, fz: 0.5719, label: 'Si47' },
    { element: 'Si', fx: 0.7499, fy: 0.8386, fz: 0.0719, label: 'Si48' },
    { element: 'Si', fx: 0.2501, fy: 0.0719, fz: 0.1614, label: 'Si49' },
    { element: 'Si', fx: 0.2501, fy: 0.5719, fz: 0.6614, label: 'Si50' },
    { element: 'Si', fx: 0.7501, fy: 0.5719, fz: 0.1614, label: 'Si51' },
    { element: 'Si', fx: 0.7501, fy: 0.0719, fz: 0.6614, label: 'Si52' },
    { element: 'Si', fx: 0.0719, fy: 0.1614, fz: 0.2501, label: 'Si53' },
    { element: 'Si', fx: 0.0719, fy: 0.6614, fz: 0.7501, label: 'Si54' },
    { element: 'Si', fx: 0.5719, fy: 0.6614, fz: 0.2501, label: 'Si55' },
    { element: 'Si', fx: 0.5719, fy: 0.1614, fz: 0.7501, label: 'Si56' },
    { element: 'Si', fx: 0.1614, fy: 0.2501, fz: 0.0719, label: 'Si57' },
    { element: 'Si', fx: 0.1614, fy: 0.7501, fz: 0.5719, label: 'Si58' },
    { element: 'Si', fx: 0.6614, fy: 0.7501, fz: 0.0719, label: 'Si59' },
    { element: 'Si', fx: 0.6614, fy: 0.2501, fz: 0.5719, label: 'Si60' },
    { element: 'Si', fx: 0.5001, fy: 0.1781, fz: 0.4114, label: 'Si61' },
    { element: 'Si', fx: 0.5001, fy: 0.6781, fz: 0.9114, label: 'Si62' },
    { element: 'Si', fx: 0.0001, fy: 0.6781, fz: 0.4114, label: 'Si63' },
    { element: 'Si', fx: 0.0001, fy: 0.1781, fz: 0.9114, label: 'Si64' },
    { element: 'Si', fx: 0.3219, fy: 0.0886, fz: 0.5001, label: 'Si65' },
    { element: 'Si', fx: 0.3219, fy: 0.5886, fz: 0.0001, label: 'Si66' },
    { element: 'Si', fx: 0.8219, fy: 0.5886, fz: 0.5001, label: 'Si67' },
    { element: 'Si', fx: 0.8219, fy: 0.0886, fz: 0.0001, label: 'Si68' },
    { element: 'Si', fx: 0.4114, fy: 0.9999, fz: 0.3219, label: 'Si69' },
    { element: 'Si', fx: 0.4114, fy: 0.4999, fz: 0.8219, label: 'Si70' },
    { element: 'Si', fx: 0.9114, fy: 0.4999, fz: 0.3219, label: 'Si71' },
    { element: 'Si', fx: 0.9114, fy: 0.9999, fz: 0.8219, label: 'Si72' },
    { element: 'Si', fx: 0.9999, fy: 0.3219, fz: 0.4114, label: 'Si73' },
    { element: 'Si', fx: 0.9999, fy: 0.8219, fz: 0.9114, label: 'Si74' },
    { element: 'Si', fx: 0.4999, fy: 0.8219, fz: 0.4114, label: 'Si75' },
    { element: 'Si', fx: 0.4999, fy: 0.3219, fz: 0.9114, label: 'Si76' },
    { element: 'Si', fx: 0.1781, fy: 0.4114, fz: 0.5001, label: 'Si77' },
    { element: 'Si', fx: 0.1781, fy: 0.9114, fz: 0.0001, label: 'Si78' },
    { element: 'Si', fx: 0.6781, fy: 0.9114, fz: 0.5001, label: 'Si79' },
    { element: 'Si', fx: 0.6781, fy: 0.4114, fz: 0.0001, label: 'Si80' },
    { element: 'Si', fx: 0.0886, fy: 0.5001, fz: 0.3219, label: 'Si81' },
    { element: 'Si', fx: 0.0886, fy: 0.0001, fz: 0.8219, label: 'Si82' },
    { element: 'Si', fx: 0.5886, fy: 0.0001, fz: 0.3219, label: 'Si83' },
    { element: 'Si', fx: 0.5886, fy: 0.5001, fz: 0.8219, label: 'Si84' },
    { element: 'Si', fx: 0.7499, fy: 0.4281, fz: 0.6614, label: 'Si85' },
    { element: 'Si', fx: 0.7499, fy: 0.9281, fz: 0.1614, label: 'Si86' },
    { element: 'Si', fx: 0.2499, fy: 0.9281, fz: 0.6614, label: 'Si87' },
    { element: 'Si', fx: 0.2499, fy: 0.4281, fz: 0.1614, label: 'Si88' },
    { element: 'Si', fx: 0.9281, fy: 0.3386, fz: 0.7501, label: 'Si89' },
    { element: 'Si', fx: 0.9281, fy: 0.8386, fz: 0.2501, label: 'Si90' },
    { element: 'Si', fx: 0.4281, fy: 0.8386, fz: 0.7501, label: 'Si91' },
    { element: 'Si', fx: 0.4281, fy: 0.3386, fz: 0.2501, label: 'Si92' },
    { element: 'Si', fx: 0.8386, fy: 0.2499, fz: 0.5719, label: 'Si93' },
    { element: 'Si', fx: 0.8386, fy: 0.7499, fz: 0.0719, label: 'Si94' },
    { element: 'Si', fx: 0.3386, fy: 0.7499, fz: 0.5719, label: 'Si95' },
    { element: 'Si', fx: 0.3386, fy: 0.2499, fz: 0.0719, label: 'Si96' },
    { element: 'Si', fx: 0.1781, fy: 0.9999, fz: 0.0886, label: 'Si97' },
    { element: 'Si', fx: 0.1781, fy: 0.4999, fz: 0.5886, label: 'Si98' },
    { element: 'Si', fx: 0.6781, fy: 0.4999, fz: 0.0886, label: 'Si99' },
    { element: 'Si', fx: 0.6781, fy: 0.9999, fz: 0.5886, label: 'Si100' },
    { element: 'Si', fx: 0.0886, fy: 0.1781, fz: 0.9999, label: 'Si101' },
    { element: 'Si', fx: 0.0886, fy: 0.6781, fz: 0.4999, label: 'Si102' },
    { element: 'Si', fx: 0.5886, fy: 0.6781, fz: 0.9999, label: 'Si103' },
    { element: 'Si', fx: 0.5886, fy: 0.1781, fz: 0.4999, label: 'Si104' },
    { element: 'Si', fx: 0.9999, fy: 0.0886, fz: 0.1781, label: 'Si105' },
    { element: 'Si', fx: 0.9999, fy: 0.5886, fz: 0.6781, label: 'Si106' },
    { element: 'Si', fx: 0.4999, fy: 0.5886, fz: 0.1781, label: 'Si107' },
    { element: 'Si', fx: 0.4999, fy: 0.0886, fz: 0.6781, label: 'Si108' },
    { element: 'Si', fx: 0.0719, fy: 0.7499, fz: 0.8386, label: 'Si109' },
    { element: 'Si', fx: 0.0719, fy: 0.2499, fz: 0.3386, label: 'Si110' },
    { element: 'Si', fx: 0.5719, fy: 0.2499, fz: 0.8386, label: 'Si111' },
    { element: 'Si', fx: 0.5719, fy: 0.7499, fz: 0.3386, label: 'Si112' },
    { element: 'Si', fx: 0.1614, fy: 0.9281, fz: 0.7499, label: 'Si113' },
    { element: 'Si', fx: 0.1614, fy: 0.4281, fz: 0.2499, label: 'Si114' },
    { element: 'Si', fx: 0.6614, fy: 0.4281, fz: 0.7499, label: 'Si115' },
    { element: 'Si', fx: 0.6614, fy: 0.9281, fz: 0.2499, label: 'Si116' },
    { element: 'Si', fx: 0.2501, fy: 0.8386, fz: 0.9281, label: 'Si117' },
    { element: 'Si', fx: 0.2501, fy: 0.3386, fz: 0.4281, label: 'Si118' },
    { element: 'Si', fx: 0.7501, fy: 0.3386, fz: 0.9281, label: 'Si119' },
    { element: 'Si', fx: 0.7501, fy: 0.8386, fz: 0.4281, label: 'Si120' },
    { element: 'Si', fx: 0.9281, fy: 0.2501, fz: 0.8386, label: 'Si121' },
    { element: 'Si', fx: 0.9281, fy: 0.7501, fz: 0.3386, label: 'Si122' },
    { element: 'Si', fx: 0.4281, fy: 0.7501, fz: 0.8386, label: 'Si123' },
    { element: 'Si', fx: 0.4281, fy: 0.2501, fz: 0.3386, label: 'Si124' },
    { element: 'Si', fx: 0.8386, fy: 0.0719, fz: 0.7499, label: 'Si125' },
    { element: 'Si', fx: 0.8386, fy: 0.5719, fz: 0.2499, label: 'Si126' },
    { element: 'Si', fx: 0.3386, fy: 0.5719, fz: 0.7499, label: 'Si127' },
    { element: 'Si', fx: 0.3386, fy: 0.0719, fz: 0.2499, label: 'Si128' },
    { element: 'Si', fx: 0.7499, fy: 0.1614, fz: 0.9281, label: 'Si129' },
    { element: 'Si', fx: 0.7499, fy: 0.6614, fz: 0.4281, label: 'Si130' },
    { element: 'Si', fx: 0.2499, fy: 0.6614, fz: 0.9281, label: 'Si131' },
    { element: 'Si', fx: 0.2499, fy: 0.1614, fz: 0.4281, label: 'Si132' },
    { element: 'Si', fx: 0.8219, fy: 0.5001, fz: 0.5886, label: 'Si133' },
    { element: 'Si', fx: 0.8219, fy: 0.0001, fz: 0.0886, label: 'Si134' },
    { element: 'Si', fx: 0.3219, fy: 0.0001, fz: 0.5886, label: 'Si135' },
    { element: 'Si', fx: 0.3219, fy: 0.5001, fz: 0.0886, label: 'Si136' },
    { element: 'Si', fx: 0.9114, fy: 0.3219, fz: 0.4999, label: 'Si137' },
    { element: 'Si', fx: 0.9114, fy: 0.8219, fz: 0.9999, label: 'Si138' },
    { element: 'Si', fx: 0.4114, fy: 0.8219, fz: 0.4999, label: 'Si139' },
    { element: 'Si', fx: 0.4114, fy: 0.3219, fz: 0.9999, label: 'Si140' },
    { element: 'Si', fx: 0.0001, fy: 0.4114, fz: 0.6781, label: 'Si141' },
    { element: 'Si', fx: 0.0001, fy: 0.9114, fz: 0.1781, label: 'Si142' },
    { element: 'Si', fx: 0.5001, fy: 0.9114, fz: 0.6781, label: 'Si143' },
    { element: 'Si', fx: 0.5001, fy: 0.4114, fz: 0.1781, label: 'Si144' },
    { element: 'Si', fx: 0.9999, fy: 0.1781, fz: 0.0886, label: 'Si145' },
    { element: 'Si', fx: 0.9999, fy: 0.6781, fz: 0.5886, label: 'Si146' },
    { element: 'Si', fx: 0.4999, fy: 0.6781, fz: 0.0886, label: 'Si147' },
    { element: 'Si', fx: 0.4999, fy: 0.1781, fz: 0.5886, label: 'Si148' },
    { element: 'Si', fx: 0.1781, fy: 0.0886, fz: 0.9999, label: 'Si149' },
    { element: 'Si', fx: 0.1781, fy: 0.5886, fz: 0.4999, label: 'Si150' },
    { element: 'Si', fx: 0.6781, fy: 0.5886, fz: 0.9999, label: 'Si151' },
    { element: 'Si', fx: 0.6781, fy: 0.0886, fz: 0.4999, label: 'Si152' },
    { element: 'Si', fx: 0.0886, fy: 0.9999, fz: 0.1781, label: 'Si153' },
    { element: 'Si', fx: 0.0886, fy: 0.4999, fz: 0.6781, label: 'Si154' },
    { element: 'Si', fx: 0.5886, fy: 0.4999, fz: 0.1781, label: 'Si155' },
    { element: 'Si', fx: 0.5886, fy: 0.9999, fz: 0.6781, label: 'Si156' },
    { element: 'Si', fx: 0.7499, fy: 0.0719, fz: 0.8386, label: 'Si157' },
    { element: 'Si', fx: 0.7499, fy: 0.5719, fz: 0.3386, label: 'Si158' },
    { element: 'Si', fx: 0.2499, fy: 0.5719, fz: 0.8386, label: 'Si159' },
    { element: 'Si', fx: 0.2499, fy: 0.0719, fz: 0.3386, label: 'Si160' },
    { element: 'Si', fx: 0.9281, fy: 0.1614, fz: 0.7499, label: 'Si161' },
    { element: 'Si', fx: 0.9281, fy: 0.6614, fz: 0.2499, label: 'Si162' },
    { element: 'Si', fx: 0.4281, fy: 0.6614, fz: 0.7499, label: 'Si163' },
    { element: 'Si', fx: 0.4281, fy: 0.1614, fz: 0.2499, label: 'Si164' },
    { element: 'Si', fx: 0.8386, fy: 0.2501, fz: 0.9281, label: 'Si165' },
    { element: 'Si', fx: 0.8386, fy: 0.7501, fz: 0.4281, label: 'Si166' },
    { element: 'Si', fx: 0.3386, fy: 0.7501, fz: 0.9281, label: 'Si167' },
    { element: 'Si', fx: 0.3386, fy: 0.2501, fz: 0.4281, label: 'Si168' },
    { element: 'Si', fx: 0.2501, fy: 0.9281, fz: 0.8386, label: 'Si169' },
    { element: 'Si', fx: 0.2501, fy: 0.4281, fz: 0.3386, label: 'Si170' },
    { element: 'Si', fx: 0.7501, fy: 0.4281, fz: 0.8386, label: 'Si171' },
    { element: 'Si', fx: 0.7501, fy: 0.9281, fz: 0.3386, label: 'Si172' },
    { element: 'Si', fx: 0.0719, fy: 0.8386, fz: 0.7499, label: 'Si173' },
    { element: 'Si', fx: 0.0719, fy: 0.3386, fz: 0.2499, label: 'Si174' },
    { element: 'Si', fx: 0.5719, fy: 0.3386, fz: 0.7499, label: 'Si175' },
    { element: 'Si', fx: 0.5719, fy: 0.8386, fz: 0.2499, label: 'Si176' },
    { element: 'Si', fx: 0.1614, fy: 0.7499, fz: 0.9281, label: 'Si177' },
    { element: 'Si', fx: 0.1614, fy: 0.2499, fz: 0.4281, label: 'Si178' },
    { element: 'Si', fx: 0.6614, fy: 0.2499, fz: 0.9281, label: 'Si179' },
    { element: 'Si', fx: 0.6614, fy: 0.7499, fz: 0.4281, label: 'Si180' },
    { element: 'Si', fx: 0.5001, fy: 0.8219, fz: 0.5886, label: 'Si181' },
    { element: 'Si', fx: 0.5001, fy: 0.3219, fz: 0.0886, label: 'Si182' },
    { element: 'Si', fx: 0.0001, fy: 0.3219, fz: 0.5886, label: 'Si183' },
    { element: 'Si', fx: 0.0001, fy: 0.8219, fz: 0.0886, label: 'Si184' },
    { element: 'Si', fx: 0.3219, fy: 0.9114, fz: 0.4999, label: 'Si185' },
    { element: 'Si', fx: 0.3219, fy: 0.4114, fz: 0.9999, label: 'Si186' },
    { element: 'Si', fx: 0.8219, fy: 0.4114, fz: 0.4999, label: 'Si187' },
    { element: 'Si', fx: 0.8219, fy: 0.9114, fz: 0.9999, label: 'Si188' },
    { element: 'Si', fx: 0.4114, fy: 0.0001, fz: 0.6781, label: 'Si189' },
    { element: 'Si', fx: 0.4114, fy: 0.5001, fz: 0.1781, label: 'Si190' },
    { element: 'Si', fx: 0.9114, fy: 0.5001, fz: 0.6781, label: 'Si191' },
    { element: 'Si', fx: 0.9114, fy: 0.0001, fz: 0.1781, label: 'Si192' },
    { element: 'O', fx: 0.0208, fy: 0.2292, fz: 0.125, label: 'O1' },
    { element: 'O', fx: 0.0208, fy: 0.7292, fz: 0.625, label: 'O2' },
    { element: 'O', fx: 0.5208, fy: 0.7292, fz: 0.125, label: 'O3' },
    { element: 'O', fx: 0.5208, fy: 0.2292, fz: 0.625, label: 'O4' },
    { element: 'O', fx: 0.125, fy: 0.0208, fz: 0.2292, label: 'O5' },
    { element: 'O', fx: 0.125, fy: 0.5208, fz: 0.7292, label: 'O6' },
    { element: 'O', fx: 0.625, fy: 0.5208, fz: 0.2292, label: 'O7' },
    { element: 'O', fx: 0.625, fy: 0.0208, fz: 0.7292, label: 'O8' },
    { element: 'O', fx: 0.2292, fy: 0.125, fz: 0.0208, label: 'O9' },
    { element: 'O', fx: 0.2292, fy: 0.625, fz: 0.5208, label: 'O10' },
    { element: 'O', fx: 0.7292, fy: 0.625, fz: 0.0208, label: 'O11' },
    { element: 'O', fx: 0.7292, fy: 0.125, fz: 0.5208, label: 'O12' },
    { element: 'O', fx: 0.2292, fy: 0.4792, fz: 0.375, label: 'O13' },
    { element: 'O', fx: 0.2292, fy: 0.9792, fz: 0.875, label: 'O14' },
    { element: 'O', fx: 0.7292, fy: 0.9792, fz: 0.375, label: 'O15' },
    { element: 'O', fx: 0.7292, fy: 0.4792, fz: 0.875, label: 'O16' },
    { element: 'O', fx: 0.125, fy: 0.2708, fz: 0.4792, label: 'O17' },
    { element: 'O', fx: 0.125, fy: 0.7708, fz: 0.9792, label: 'O18' },
    { element: 'O', fx: 0.625, fy: 0.7708, fz: 0.4792, label: 'O19' },
    { element: 'O', fx: 0.625, fy: 0.2708, fz: 0.9792, label: 'O20' },
    { element: 'O', fx: 0.0208, fy: 0.375, fz: 0.2708, label: 'O21' },
    { element: 'O', fx: 0.0208, fy: 0.875, fz: 0.7708, label: 'O22' },
    { element: 'O', fx: 0.5208, fy: 0.875, fz: 0.2708, label: 'O23' },
    { element: 'O', fx: 0.5208, fy: 0.375, fz: 0.7708, label: 'O24' },
    { element: 'O', fx: 0.2708, fy: 0.0208, fz: 0.375, label: 'O25' },
    { element: 'O', fx: 0.2708, fy: 0.5208, fz: 0.875, label: 'O26' },
    { element: 'O', fx: 0.7708, fy: 0.5208, fz: 0.375, label: 'O27' },
    { element: 'O', fx: 0.7708, fy: 0.0208, fz: 0.875, label: 'O28' },
    { element: 'O', fx: 0.375, fy: 0.2292, fz: 0.4792, label: 'O29' },
    { element: 'O', fx: 0.375, fy: 0.7292, fz: 0.9792, label: 'O30' },
    { element: 'O', fx: 0.875, fy: 0.7292, fz: 0.4792, label: 'O31' },
    { element: 'O', fx: 0.875, fy: 0.2292, fz: 0.9792, label: 'O32' },
    { element: 'O', fx: 0.4792, fy: 0.125, fz: 0.2708, label: 'O33' },
    { element: 'O', fx: 0.4792, fy: 0.625, fz: 0.7708, label: 'O34' },
    { element: 'O', fx: 0.9792, fy: 0.625, fz: 0.2708, label: 'O35' },
    { element: 'O', fx: 0.9792, fy: 0.125, fz: 0.7708, label: 'O36' },
    { element: 'O', fx: 0.4792, fy: 0.7708, fz: 0.625, label: 'O37' },
    { element: 'O', fx: 0.4792, fy: 0.2708, fz: 0.125, label: 'O38' },
    { element: 'O', fx: 0.9792, fy: 0.2708, fz: 0.625, label: 'O39' },
    { element: 'O', fx: 0.9792, fy: 0.7708, fz: 0.125, label: 'O40' },
    { element: 'O', fx: 0.375, fy: 0.9792, fz: 0.7292, label: 'O41' },
    { element: 'O', fx: 0.375, fy: 0.4792, fz: 0.2292, label: 'O42' },
    { element: 'O', fx: 0.875, fy: 0.4792, fz: 0.7292, label: 'O43' },
    { element: 'O', fx: 0.875, fy: 0.9792, fz: 0.2292, label: 'O44' },
    { element: 'O', fx: 0.2708, fy: 0.875, fz: 0.5208, label: 'O45' },
    { element: 'O', fx: 0.2708, fy: 0.375, fz: 0.0208, label: 'O46' },
    { element: 'O', fx: 0.7708, fy: 0.375, fz: 0.5208, label: 'O47' },
    { element: 'O', fx: 0.7708, fy: 0.875, fz: 0.0208, label: 'O48' },
    { element: 'O', fx: 0.2292, fy: 0.0208, fz: 0.125, label: 'O49' },
    { element: 'O', fx: 0.2292, fy: 0.5208, fz: 0.625, label: 'O50' },
    { element: 'O', fx: 0.7292, fy: 0.5208, fz: 0.125, label: 'O51' },
    { element: 'O', fx: 0.7292, fy: 0.0208, fz: 0.625, label: 'O52' },
    { element: 'O', fx: 0.0208, fy: 0.125, fz: 0.2292, label: 'O53' },
    { element: 'O', fx: 0.0208, fy: 0.625, fz: 0.7292, label: 'O54' },
    { element: 'O', fx: 0.5208, fy: 0.625, fz: 0.2292, label: 'O55' },
    { element: 'O', fx: 0.5208, fy: 0.125, fz: 0.7292, label: 'O56' },
    { element: 'O', fx: 0.125, fy: 0.2292, fz: 0.0208, label: 'O57' },
    { element: 'O', fx: 0.125, fy: 0.7292, fz: 0.5208, label: 'O58' },
    { element: 'O', fx: 0.625, fy: 0.7292, fz: 0.0208, label: 'O59' },
    { element: 'O', fx: 0.625, fy: 0.2292, fz: 0.5208, label: 'O60' },
    { element: 'O', fx: 0.4792, fy: 0.2292, fz: 0.375, label: 'O61' },
    { element: 'O', fx: 0.4792, fy: 0.7292, fz: 0.875, label: 'O62' },
    { element: 'O', fx: 0.9792, fy: 0.7292, fz: 0.375, label: 'O63' },
    { element: 'O', fx: 0.9792, fy: 0.2292, fz: 0.875, label: 'O64' },
    { element: 'O', fx: 0.2708, fy: 0.125, fz: 0.4792, label: 'O65' },
    { element: 'O', fx: 0.2708, fy: 0.625, fz: 0.9792, label: 'O66' },
    { element: 'O', fx: 0.7708, fy: 0.625, fz: 0.4792, label: 'O67' },
    { element: 'O', fx: 0.7708, fy: 0.125, fz: 0.9792, label: 'O68' },
    { element: 'O', fx: 0.375, fy: 0.0208, fz: 0.2708, label: 'O69' },
    { element: 'O', fx: 0.375, fy: 0.5208, fz: 0.7708, label: 'O70' },
    { element: 'O', fx: 0.875, fy: 0.5208, fz: 0.2708, label: 'O71' },
    { element: 'O', fx: 0.875, fy: 0.0208, fz: 0.7708, label: 'O72' },
    { element: 'O', fx: 0.0208, fy: 0.2708, fz: 0.375, label: 'O73' },
    { element: 'O', fx: 0.0208, fy: 0.7708, fz: 0.875, label: 'O74' },
    { element: 'O', fx: 0.5208, fy: 0.7708, fz: 0.375, label: 'O75' },
    { element: 'O', fx: 0.5208, fy: 0.2708, fz: 0.875, label: 'O76' },
    { element: 'O', fx: 0.2292, fy: 0.375, fz: 0.4792, label: 'O77' },
    { element: 'O', fx: 0.2292, fy: 0.875, fz: 0.9792, label: 'O78' },
    { element: 'O', fx: 0.7292, fy: 0.875, fz: 0.4792, label: 'O79' },
    { element: 'O', fx: 0.7292, fy: 0.375, fz: 0.9792, label: 'O80' },
    { element: 'O', fx: 0.125, fy: 0.4792, fz: 0.2708, label: 'O81' },
    { element: 'O', fx: 0.125, fy: 0.9792, fz: 0.7708, label: 'O82' },
    { element: 'O', fx: 0.625, fy: 0.9792, fz: 0.2708, label: 'O83' },
    { element: 'O', fx: 0.625, fy: 0.4792, fz: 0.7708, label: 'O84' },
    { element: 'O', fx: 0.7708, fy: 0.4792, fz: 0.625, label: 'O85' },
    { element: 'O', fx: 0.7708, fy: 0.9792, fz: 0.125, label: 'O86' },
    { element: 'O', fx: 0.2708, fy: 0.9792, fz: 0.625, label: 'O87' },
    { element: 'O', fx: 0.2708, fy: 0.4792, fz: 0.125, label: 'O88' },
    { element: 'O', fx: 0.9792, fy: 0.375, fz: 0.7292, label: 'O89' },
    { element: 'O', fx: 0.9792, fy: 0.875, fz: 0.2292, label: 'O90' },
    { element: 'O', fx: 0.4792, fy: 0.875, fz: 0.7292, label: 'O91' },
    { element: 'O', fx: 0.4792, fy: 0.375, fz: 0.2292, label: 'O92' },
    { element: 'O', fx: 0.875, fy: 0.2708, fz: 0.5208, label: 'O93' },
    { element: 'O', fx: 0.875, fy: 0.7708, fz: 0.0208, label: 'O94' },
    { element: 'O', fx: 0.375, fy: 0.7708, fz: 0.5208, label: 'O95' },
    { element: 'O', fx: 0.375, fy: 0.2708, fz: 0.0208, label: 'O96' },
    { element: 'O', fx: 0.0919, fy: 0.2012, fz: 0.2012, label: 'O97' },
    { element: 'O', fx: 0.0919, fy: 0.7012, fz: 0.7012, label: 'O98' },
    { element: 'O', fx: 0.5919, fy: 0.7012, fz: 0.2012, label: 'O99' },
    { element: 'O', fx: 0.5919, fy: 0.2012, fz: 0.7012, label: 'O100' },
    { element: 'O', fx: 0.2012, fy: 0.0919, fz: 0.2012, label: 'O101' },
    { element: 'O', fx: 0.2012, fy: 0.5919, fz: 0.7012, label: 'O102' },
    { element: 'O', fx: 0.7012, fy: 0.5919, fz: 0.2012, label: 'O103' },
    { element: 'O', fx: 0.7012, fy: 0.0919, fz: 0.7012, label: 'O104' },
    { element: 'O', fx: 0.2012, fy: 0.2012, fz: 0.0919, label: 'O105' },
    { element: 'O', fx: 0.2012, fy: 0.7012, fz: 0.5919, label: 'O106' },
    { element: 'O', fx: 0.7012, fy: 0.7012, fz: 0.0919, label: 'O107' },
    { element: 'O', fx: 0.7012, fy: 0.2012, fz: 0.5919, label: 'O108' },
    { element: 'O', fx: 0.1581, fy: 0.4512, fz: 0.4512, label: 'O109' },
    { element: 'O', fx: 0.1581, fy: 0.9512, fz: 0.9512, label: 'O110' },
    { element: 'O', fx: 0.6581, fy: 0.9512, fz: 0.4512, label: 'O111' },
    { element: 'O', fx: 0.6581, fy: 0.4512, fz: 0.9512, label: 'O112' },
    { element: 'O', fx: 0.0488, fy: 0.3419, fz: 0.4512, label: 'O113' },
    { element: 'O', fx: 0.0488, fy: 0.8419, fz: 0.9512, label: 'O114' },
    { element: 'O', fx: 0.5488, fy: 0.8419, fz: 0.4512, label: 'O115' },
    { element: 'O', fx: 0.5488, fy: 0.3419, fz: 0.9512, label: 'O116' },
    { element: 'O', fx: 0.0488, fy: 0.4512, fz: 0.3419, label: 'O117' },
    { element: 'O', fx: 0.0488, fy: 0.9512, fz: 0.8419, label: 'O118' },
    { element: 'O', fx: 0.5488, fy: 0.9512, fz: 0.3419, label: 'O119' },
    { element: 'O', fx: 0.5488, fy: 0.4512, fz: 0.8419, label: 'O120' },
    { element: 'O', fx: 0.3419, fy: 0.0488, fz: 0.4512, label: 'O121' },
    { element: 'O', fx: 0.3419, fy: 0.5488, fz: 0.9512, label: 'O122' },
    { element: 'O', fx: 0.8419, fy: 0.5488, fz: 0.4512, label: 'O123' },
    { element: 'O', fx: 0.8419, fy: 0.0488, fz: 0.9512, label: 'O124' },
    { element: 'O', fx: 0.4512, fy: 0.1581, fz: 0.4512, label: 'O125' },
    { element: 'O', fx: 0.4512, fy: 0.6581, fz: 0.9512, label: 'O126' },
    { element: 'O', fx: 0.9512, fy: 0.6581, fz: 0.4512, label: 'O127' },
    { element: 'O', fx: 0.9512, fy: 0.1581, fz: 0.9512, label: 'O128' },
    { element: 'O', fx: 0.4512, fy: 0.0488, fz: 0.3419, label: 'O129' },
    { element: 'O', fx: 0.4512, fy: 0.5488, fz: 0.8419, label: 'O130' },
    { element: 'O', fx: 0.9512, fy: 0.5488, fz: 0.3419, label: 'O131' },
    { element: 'O', fx: 0.9512, fy: 0.0488, fz: 0.8419, label: 'O132' },
    { element: 'O', fx: 0.4081, fy: 0.7988, fz: 0.7012, label: 'O133' },
    { element: 'O', fx: 0.4081, fy: 0.2988, fz: 0.2012, label: 'O134' },
    { element: 'O', fx: 0.9081, fy: 0.2988, fz: 0.7012, label: 'O135' },
    { element: 'O', fx: 0.9081, fy: 0.7988, fz: 0.2012, label: 'O136' },
    { element: 'O', fx: 0.2988, fy: 0.9081, fz: 0.7012, label: 'O137' },
    { element: 'O', fx: 0.2988, fy: 0.4081, fz: 0.2012, label: 'O138' },
    { element: 'O', fx: 0.7988, fy: 0.4081, fz: 0.7012, label: 'O139' },
    { element: 'O', fx: 0.7988, fy: 0.9081, fz: 0.2012, label: 'O140' },
    { element: 'O', fx: 0.2988, fy: 0.7988, fz: 0.5919, label: 'O141' },
    { element: 'O', fx: 0.2988, fy: 0.2988, fz: 0.0919, label: 'O142' },
    { element: 'O', fx: 0.7988, fy: 0.2988, fz: 0.5919, label: 'O143' },
    { element: 'O', fx: 0.7988, fy: 0.7988, fz: 0.0919, label: 'O144' },
    { element: 'O', fx: 0.1581, fy: 0.0488, fz: 0.0488, label: 'O145' },
    { element: 'O', fx: 0.1581, fy: 0.5488, fz: 0.5488, label: 'O146' },
    { element: 'O', fx: 0.6581, fy: 0.5488, fz: 0.0488, label: 'O147' },
    { element: 'O', fx: 0.6581, fy: 0.0488, fz: 0.5488, label: 'O148' },
    { element: 'O', fx: 0.0488, fy: 0.1581, fz: 0.0488, label: 'O149' },
    { element: 'O', fx: 0.0488, fy: 0.6581, fz: 0.5488, label: 'O150' },
    { element: 'O', fx: 0.5488, fy: 0.6581, fz: 0.0488, label: 'O151' },
    { element: 'O', fx: 0.5488, fy: 0.1581, fz: 0.5488, label: 'O152' },
    { element: 'O', fx: 0.0488, fy: 0.0488, fz: 0.1581, label: 'O153' },
    { element: 'O', fx: 0.0488, fy: 0.5488, fz: 0.6581, label: 'O154' },
    { element: 'O', fx: 0.5488, fy: 0.5488, fz: 0.1581, label: 'O155' },
    { element: 'O', fx: 0.5488, fy: 0.0488, fz: 0.6581, label: 'O156' },
    { element: 'O', fx: 0.0919, fy: 0.7988, fz: 0.7988, label: 'O157' },
    { element: 'O', fx: 0.0919, fy: 0.2988, fz: 0.2988, label: 'O158' },
    { element: 'O', fx: 0.5919, fy: 0.2988, fz: 0.7988, label: 'O159' },
    { element: 'O', fx: 0.5919, fy: 0.7988, fz: 0.2988, label: 'O160' },
    { element: 'O', fx: 0.2012, fy: 0.9081, fz: 0.7988, label: 'O161' },
    { element: 'O', fx: 0.2012, fy: 0.4081, fz: 0.2988, label: 'O162' },
    { element: 'O', fx: 0.7012, fy: 0.4081, fz: 0.7988, label: 'O163' },
    { element: 'O', fx: 0.7012, fy: 0.9081, fz: 0.2988, label: 'O164' },
    { element: 'O', fx: 0.2012, fy: 0.7988, fz: 0.9081, label: 'O165' },
    { element: 'O', fx: 0.2012, fy: 0.2988, fz: 0.4081, label: 'O166' },
    { element: 'O', fx: 0.7012, fy: 0.2988, fz: 0.9081, label: 'O167' },
    { element: 'O', fx: 0.7012, fy: 0.7988, fz: 0.4081, label: 'O168' },
    { element: 'O', fx: 0.9081, fy: 0.2012, fz: 0.7988, label: 'O169' },
    { element: 'O', fx: 0.9081, fy: 0.7012, fz: 0.2988, label: 'O170' },
    { element: 'O', fx: 0.4081, fy: 0.7012, fz: 0.7988, label: 'O171' },
    { element: 'O', fx: 0.4081, fy: 0.2012, fz: 0.2988, label: 'O172' },
    { element: 'O', fx: 0.7988, fy: 0.0919, fz: 0.7988, label: 'O173' },
    { element: 'O', fx: 0.7988, fy: 0.5919, fz: 0.2988, label: 'O174' },
    { element: 'O', fx: 0.2988, fy: 0.5919, fz: 0.7988, label: 'O175' },
    { element: 'O', fx: 0.2988, fy: 0.0919, fz: 0.2988, label: 'O176' },
    { element: 'O', fx: 0.7988, fy: 0.2012, fz: 0.9081, label: 'O177' },
    { element: 'O', fx: 0.7988, fy: 0.7012, fz: 0.4081, label: 'O178' },
    { element: 'O', fx: 0.2988, fy: 0.7012, fz: 0.9081, label: 'O179' },
    { element: 'O', fx: 0.2988, fy: 0.2012, fz: 0.4081, label: 'O180' },
    { element: 'O', fx: 0.8419, fy: 0.4512, fz: 0.5488, label: 'O181' },
    { element: 'O', fx: 0.8419, fy: 0.9512, fz: 0.0488, label: 'O182' },
    { element: 'O', fx: 0.3419, fy: 0.9512, fz: 0.5488, label: 'O183' },
    { element: 'O', fx: 0.3419, fy: 0.4512, fz: 0.0488, label: 'O184' },
    { element: 'O', fx: 0.9512, fy: 0.3419, fz: 0.5488, label: 'O185' },
    { element: 'O', fx: 0.9512, fy: 0.8419, fz: 0.0488, label: 'O186' },
    { element: 'O', fx: 0.4512, fy: 0.8419, fz: 0.5488, label: 'O187' },
    { element: 'O', fx: 0.4512, fy: 0.3419, fz: 0.0488, label: 'O188' },
    { element: 'O', fx: 0.9512, fy: 0.4512, fz: 0.6581, label: 'O189' },
    { element: 'O', fx: 0.9512, fy: 0.9512, fz: 0.1581, label: 'O190' },
    { element: 'O', fx: 0.4512, fy: 0.9512, fz: 0.6581, label: 'O191' },
    { element: 'O', fx: 0.4512, fy: 0.4512, fz: 0.1581, label: 'O192' },
    { element: 'O', fx: 0.1216, fy: 0.2679, fz: 0.1216, label: 'O193' },
    { element: 'O', fx: 0.1216, fy: 0.7679, fz: 0.6216, label: 'O194' },
    { element: 'O', fx: 0.6216, fy: 0.7679, fz: 0.1216, label: 'O195' },
    { element: 'O', fx: 0.6216, fy: 0.2679, fz: 0.6216, label: 'O196' },
    { element: 'O', fx: 0.1216, fy: 0.1216, fz: 0.2679, label: 'O197' },
    { element: 'O', fx: 0.1216, fy: 0.6216, fz: 0.7679, label: 'O198' },
    { element: 'O', fx: 0.6216, fy: 0.6216, fz: 0.2679, label: 'O199' },
    { element: 'O', fx: 0.6216, fy: 0.1216, fz: 0.7679, label: 'O200' },
    { element: 'O', fx: 0.2679, fy: 0.1216, fz: 0.1216, label: 'O201' },
    { element: 'O', fx: 0.2679, fy: 0.6216, fz: 0.6216, label: 'O202' },
    { element: 'O', fx: 0.7679, fy: 0.6216, fz: 0.1216, label: 'O203' },
    { element: 'O', fx: 0.7679, fy: 0.1216, fz: 0.6216, label: 'O204' },
    { element: 'O', fx: 0.1284, fy: 0.5179, fz: 0.3716, label: 'O205' },
    { element: 'O', fx: 0.1284, fy: 0.0179, fz: 0.8716, label: 'O206' },
    { element: 'O', fx: 0.6284, fy: 0.0179, fz: 0.3716, label: 'O207' },
    { element: 'O', fx: 0.6284, fy: 0.5179, fz: 0.8716, label: 'O208' },
    { element: 'O', fx: 0.1284, fy: 0.3716, fz: 0.5179, label: 'O209' },
    { element: 'O', fx: 0.1284, fy: 0.8716, fz: 0.0179, label: 'O210' },
    { element: 'O', fx: 0.6284, fy: 0.8716, fz: 0.5179, label: 'O211' },
    { element: 'O', fx: 0.6284, fy: 0.3716, fz: 0.0179, label: 'O212' },
    { element: 'O', fx: 0.9821, fy: 0.3716, fz: 0.3716, label: 'O213' },
    { element: 'O', fx: 0.9821, fy: 0.8716, fz: 0.8716, label: 'O214' },
    { element: 'O', fx: 0.4821, fy: 0.8716, fz: 0.3716, label: 'O215' },
    { element: 'O', fx: 0.4821, fy: 0.3716, fz: 0.8716, label: 'O216' },
    { element: 'O', fx: 0.3716, fy: 0.9821, fz: 0.3716, label: 'O217' },
    { element: 'O', fx: 0.3716, fy: 0.4821, fz: 0.8716, label: 'O218' },
    { element: 'O', fx: 0.8716, fy: 0.4821, fz: 0.3716, label: 'O219' },
    { element: 'O', fx: 0.8716, fy: 0.9821, fz: 0.8716, label: 'O220' },
    { element: 'O', fx: 0.3716, fy: 0.1284, fz: 0.5179, label: 'O221' },
    { element: 'O', fx: 0.3716, fy: 0.6284, fz: 0.0179, label: 'O222' },
    { element: 'O', fx: 0.8716, fy: 0.6284, fz: 0.5179, label: 'O223' },
    { element: 'O', fx: 0.8716, fy: 0.1284, fz: 0.0179, label: 'O224' },
    { element: 'O', fx: 0.5179, fy: 0.1284, fz: 0.3716, label: 'O225' },
    { element: 'O', fx: 0.5179, fy: 0.6284, fz: 0.8716, label: 'O226' },
    { element: 'O', fx: 0.0179, fy: 0.6284, fz: 0.3716, label: 'O227' },
    { element: 'O', fx: 0.0179, fy: 0.1284, fz: 0.8716, label: 'O228' },
    { element: 'O', fx: 0.3784, fy: 0.7321, fz: 0.6216, label: 'O229' },
    { element: 'O', fx: 0.3784, fy: 0.2321, fz: 0.1216, label: 'O230' },
    { element: 'O', fx: 0.8784, fy: 0.2321, fz: 0.6216, label: 'O231' },
    { element: 'O', fx: 0.8784, fy: 0.7321, fz: 0.1216, label: 'O232' },
    { element: 'O', fx: 0.3784, fy: 0.8784, fz: 0.7679, label: 'O233' },
    { element: 'O', fx: 0.3784, fy: 0.3784, fz: 0.2679, label: 'O234' },
    { element: 'O', fx: 0.8784, fy: 0.3784, fz: 0.7679, label: 'O235' },
    { element: 'O', fx: 0.8784, fy: 0.8784, fz: 0.2679, label: 'O236' },
    { element: 'O', fx: 0.2321, fy: 0.8784, fz: 0.6216, label: 'O237' },
    { element: 'O', fx: 0.2321, fy: 0.3784, fz: 0.1216, label: 'O238' },
    { element: 'O', fx: 0.7321, fy: 0.3784, fz: 0.6216, label: 'O239' },
    { element: 'O', fx: 0.7321, fy: 0.8784, fz: 0.1216, label: 'O240' },
    { element: 'O', fx: 0.1284, fy: 0.9821, fz: 0.1284, label: 'O241' },
    { element: 'O', fx: 0.1284, fy: 0.4821, fz: 0.6284, label: 'O242' },
    { element: 'O', fx: 0.6284, fy: 0.4821, fz: 0.1284, label: 'O243' },
    { element: 'O', fx: 0.6284, fy: 0.9821, fz: 0.6284, label: 'O244' },
    { element: 'O', fx: 0.1284, fy: 0.1284, fz: 0.9821, label: 'O245' },
    { element: 'O', fx: 0.1284, fy: 0.6284, fz: 0.4821, label: 'O246' },
    { element: 'O', fx: 0.6284, fy: 0.6284, fz: 0.9821, label: 'O247' },
    { element: 'O', fx: 0.6284, fy: 0.1284, fz: 0.4821, label: 'O248' },
    { element: 'O', fx: 0.9821, fy: 0.1284, fz: 0.1284, label: 'O249' },
    { element: 'O', fx: 0.9821, fy: 0.6284, fz: 0.6284, label: 'O250' },
    { element: 'O', fx: 0.4821, fy: 0.6284, fz: 0.1284, label: 'O251' },
    { element: 'O', fx: 0.4821, fy: 0.1284, fz: 0.6284, label: 'O252' },
    { element: 'O', fx: 0.1216, fy: 0.7321, fz: 0.8784, label: 'O253' },
    { element: 'O', fx: 0.1216, fy: 0.2321, fz: 0.3784, label: 'O254' },
    { element: 'O', fx: 0.6216, fy: 0.2321, fz: 0.8784, label: 'O255' },
    { element: 'O', fx: 0.6216, fy: 0.7321, fz: 0.3784, label: 'O256' },
    { element: 'O', fx: 0.1216, fy: 0.8784, fz: 0.7321, label: 'O257' },
    { element: 'O', fx: 0.1216, fy: 0.3784, fz: 0.2321, label: 'O258' },
    { element: 'O', fx: 0.6216, fy: 0.3784, fz: 0.7321, label: 'O259' },
    { element: 'O', fx: 0.6216, fy: 0.8784, fz: 0.2321, label: 'O260' },
    { element: 'O', fx: 0.2679, fy: 0.8784, fz: 0.8784, label: 'O261' },
    { element: 'O', fx: 0.2679, fy: 0.3784, fz: 0.3784, label: 'O262' },
    { element: 'O', fx: 0.7679, fy: 0.3784, fz: 0.8784, label: 'O263' },
    { element: 'O', fx: 0.7679, fy: 0.8784, fz: 0.3784, label: 'O264' },
    { element: 'O', fx: 0.8784, fy: 0.2679, fz: 0.8784, label: 'O265' },
    { element: 'O', fx: 0.8784, fy: 0.7679, fz: 0.3784, label: 'O266' },
    { element: 'O', fx: 0.3784, fy: 0.7679, fz: 0.8784, label: 'O267' },
    { element: 'O', fx: 0.3784, fy: 0.2679, fz: 0.3784, label: 'O268' },
    { element: 'O', fx: 0.8784, fy: 0.1216, fz: 0.7321, label: 'O269' },
    { element: 'O', fx: 0.8784, fy: 0.6216, fz: 0.2321, label: 'O270' },
    { element: 'O', fx: 0.3784, fy: 0.6216, fz: 0.7321, label: 'O271' },
    { element: 'O', fx: 0.3784, fy: 0.1216, fz: 0.2321, label: 'O272' },
    { element: 'O', fx: 0.7321, fy: 0.1216, fz: 0.8784, label: 'O273' },
    { element: 'O', fx: 0.7321, fy: 0.6216, fz: 0.3784, label: 'O274' },
    { element: 'O', fx: 0.2321, fy: 0.6216, fz: 0.8784, label: 'O275' },
    { element: 'O', fx: 0.2321, fy: 0.1216, fz: 0.3784, label: 'O276' },
    { element: 'O', fx: 0.8716, fy: 0.5179, fz: 0.6284, label: 'O277' },
    { element: 'O', fx: 0.8716, fy: 0.0179, fz: 0.1284, label: 'O278' },
    { element: 'O', fx: 0.3716, fy: 0.0179, fz: 0.6284, label: 'O279' },
    { element: 'O', fx: 0.3716, fy: 0.5179, fz: 0.1284, label: 'O280' },
    { element: 'O', fx: 0.8716, fy: 0.3716, fz: 0.4821, label: 'O281' },
    { element: 'O', fx: 0.8716, fy: 0.8716, fz: 0.9821, label: 'O282' },
    { element: 'O', fx: 0.3716, fy: 0.8716, fz: 0.4821, label: 'O283' },
    { element: 'O', fx: 0.3716, fy: 0.3716, fz: 0.9821, label: 'O284' },
    { element: 'O', fx: 0.0179, fy: 0.3716, fz: 0.6284, label: 'O285' },
    { element: 'O', fx: 0.0179, fy: 0.8716, fz: 0.1284, label: 'O286' },
    { element: 'O', fx: 0.5179, fy: 0.8716, fz: 0.6284, label: 'O287' },
    { element: 'O', fx: 0.5179, fy: 0.3716, fz: 0.1284, label: 'O288' },
    { element: 'O', fx: 0.0533, fy: 0.302, fz: 0.198, label: 'O289' },
    { element: 'O', fx: 0.0533, fy: 0.802, fz: 0.698, label: 'O290' },
    { element: 'O', fx: 0.5533, fy: 0.802, fz: 0.198, label: 'O291' },
    { element: 'O', fx: 0.5533, fy: 0.302, fz: 0.698, label: 'O292' },
    { element: 'O', fx: 0.198, fy: 0.0533, fz: 0.302, label: 'O293' },
    { element: 'O', fx: 0.198, fy: 0.5533, fz: 0.802, label: 'O294' },
    { element: 'O', fx: 0.698, fy: 0.5533, fz: 0.302, label: 'O295' },
    { element: 'O', fx: 0.698, fy: 0.0533, fz: 0.802, label: 'O296' },
    { element: 'O', fx: 0.302, fy: 0.198, fz: 0.0533, label: 'O297' },
    { element: 'O', fx: 0.302, fy: 0.698, fz: 0.5533, label: 'O298' },
    { element: 'O', fx: 0.802, fy: 0.698, fz: 0.0533, label: 'O299' },
    { element: 'O', fx: 0.802, fy: 0.198, fz: 0.5533, label: 'O300' },
    { element: 'O', fx: 0.1967, fy: 0.552, fz: 0.448, label: 'O301' },
    { element: 'O', fx: 0.1967, fy: 0.052, fz: 0.948, label: 'O302' },
    { element: 'O', fx: 0.6967, fy: 0.052, fz: 0.448, label: 'O303' },
    { element: 'O', fx: 0.6967, fy: 0.552, fz: 0.948, label: 'O304' },
    { element: 'O', fx: 0.052, fy: 0.3033, fz: 0.552, label: 'O305' },
    { element: 'O', fx: 0.052, fy: 0.8033, fz: 0.052, label: 'O306' },
    { element: 'O', fx: 0.552, fy: 0.8033, fz: 0.552, label: 'O307' },
    { element: 'O', fx: 0.552, fy: 0.3033, fz: 0.052, label: 'O308' },
    { element: 'O', fx: 0.948, fy: 0.448, fz: 0.3033, label: 'O309' },
    { element: 'O', fx: 0.948, fy: 0.948, fz: 0.8033, label: 'O310' },
    { element: 'O', fx: 0.448, fy: 0.948, fz: 0.3033, label: 'O311' },
    { element: 'O', fx: 0.448, fy: 0.448, fz: 0.8033, label: 'O312' },
    { element: 'O', fx: 0.3033, fy: 0.948, fz: 0.448, label: 'O313' },
    { element: 'O', fx: 0.3033, fy: 0.448, fz: 0.948, label: 'O314' },
    { element: 'O', fx: 0.8033, fy: 0.448, fz: 0.448, label: 'O315' },
    { element: 'O', fx: 0.8033, fy: 0.948, fz: 0.948, label: 'O316' },
    { element: 'O', fx: 0.448, fy: 0.1967, fz: 0.552, label: 'O317' },
    { element: 'O', fx: 0.448, fy: 0.6967, fz: 0.052, label: 'O318' },
    { element: 'O', fx: 0.948, fy: 0.6967, fz: 0.552, label: 'O319' },
    { element: 'O', fx: 0.948, fy: 0.1967, fz: 0.052, label: 'O320' },
    { element: 'O', fx: 0.552, fy: 0.052, fz: 0.3033, label: 'O321' },
    { element: 'O', fx: 0.552, fy: 0.552, fz: 0.8033, label: 'O322' },
    { element: 'O', fx: 0.052, fy: 0.552, fz: 0.3033, label: 'O323' },
    { element: 'O', fx: 0.052, fy: 0.052, fz: 0.8033, label: 'O324' },
    { element: 'O', fx: 0.4467, fy: 0.698, fz: 0.698, label: 'O325' },
    { element: 'O', fx: 0.4467, fy: 0.198, fz: 0.198, label: 'O326' },
    { element: 'O', fx: 0.9467, fy: 0.198, fz: 0.698, label: 'O327' },
    { element: 'O', fx: 0.9467, fy: 0.698, fz: 0.198, label: 'O328' },
    { element: 'O', fx: 0.302, fy: 0.9467, fz: 0.802, label: 'O329' },
    { element: 'O', fx: 0.302, fy: 0.4467, fz: 0.302, label: 'O330' },
    { element: 'O', fx: 0.802, fy: 0.4467, fz: 0.802, label: 'O331' },
    { element: 'O', fx: 0.802, fy: 0.9467, fz: 0.302, label: 'O332' },
    { element: 'O', fx: 0.198, fy: 0.802, fz: 0.5533, label: 'O333' },
    { element: 'O', fx: 0.198, fy: 0.302, fz: 0.0533, label: 'O334' },
    { element: 'O', fx: 0.698, fy: 0.302, fz: 0.5533, label: 'O335' },
    { element: 'O', fx: 0.698, fy: 0.802, fz: 0.0533, label: 'O336' },
    { element: 'O', fx: 0.302, fy: 0.0533, fz: 0.198, label: 'O337' },
    { element: 'O', fx: 0.302, fy: 0.5533, fz: 0.698, label: 'O338' },
    { element: 'O', fx: 0.802, fy: 0.5533, fz: 0.198, label: 'O339' },
    { element: 'O', fx: 0.802, fy: 0.0533, fz: 0.698, label: 'O340' },
    { element: 'O', fx: 0.0533, fy: 0.198, fz: 0.302, label: 'O341' },
    { element: 'O', fx: 0.0533, fy: 0.698, fz: 0.802, label: 'O342' },
    { element: 'O', fx: 0.5533, fy: 0.698, fz: 0.302, label: 'O343' },
    { element: 'O', fx: 0.5533, fy: 0.198, fz: 0.802, label: 'O344' },
    { element: 'O', fx: 0.552, fy: 0.1967, fz: 0.448, label: 'O345' },
    { element: 'O', fx: 0.552, fy: 0.6967, fz: 0.948, label: 'O346' },
    { element: 'O', fx: 0.052, fy: 0.6967, fz: 0.448, label: 'O347' },
    { element: 'O', fx: 0.052, fy: 0.1967, fz: 0.948, label: 'O348' },
    { element: 'O', fx: 0.3033, fy: 0.052, fz: 0.552, label: 'O349' },
    { element: 'O', fx: 0.3033, fy: 0.552, fz: 0.052, label: 'O350' },
    { element: 'O', fx: 0.8033, fy: 0.552, fz: 0.552, label: 'O351' },
    { element: 'O', fx: 0.8033, fy: 0.052, fz: 0.052, label: 'O352' },
    { element: 'O', fx: 0.948, fy: 0.3033, fz: 0.448, label: 'O353' },
    { element: 'O', fx: 0.948, fy: 0.8033, fz: 0.948, label: 'O354' },
    { element: 'O', fx: 0.448, fy: 0.8033, fz: 0.448, label: 'O355' },
    { element: 'O', fx: 0.448, fy: 0.3033, fz: 0.948, label: 'O356' },
    { element: 'O', fx: 0.1967, fy: 0.448, fz: 0.552, label: 'O357' },
    { element: 'O', fx: 0.1967, fy: 0.948, fz: 0.052, label: 'O358' },
    { element: 'O', fx: 0.6967, fy: 0.948, fz: 0.552, label: 'O359' },
    { element: 'O', fx: 0.6967, fy: 0.448, fz: 0.052, label: 'O360' },
    { element: 'O', fx: 0.698, fy: 0.4467, fz: 0.698, label: 'O361' },
    { element: 'O', fx: 0.698, fy: 0.9467, fz: 0.198, label: 'O362' },
    { element: 'O', fx: 0.198, fy: 0.9467, fz: 0.698, label: 'O363' },
    { element: 'O', fx: 0.198, fy: 0.4467, fz: 0.198, label: 'O364' },
    { element: 'O', fx: 0.9467, fy: 0.302, fz: 0.802, label: 'O365' },
    { element: 'O', fx: 0.9467, fy: 0.802, fz: 0.302, label: 'O366' },
    { element: 'O', fx: 0.4467, fy: 0.802, fz: 0.802, label: 'O367' },
    { element: 'O', fx: 0.4467, fy: 0.302, fz: 0.302, label: 'O368' },
    { element: 'O', fx: 0.948, fy: 0.052, fz: 0.1967, label: 'O369' },
    { element: 'O', fx: 0.948, fy: 0.552, fz: 0.6967, label: 'O370' },
    { element: 'O', fx: 0.448, fy: 0.552, fz: 0.1967, label: 'O371' },
    { element: 'O', fx: 0.448, fy: 0.052, fz: 0.6967, label: 'O372' },
    { element: 'O', fx: 0.302, fy: 0.802, fz: 0.9467, label: 'O373' },
    { element: 'O', fx: 0.302, fy: 0.302, fz: 0.4467, label: 'O374' },
    { element: 'O', fx: 0.802, fy: 0.302, fz: 0.9467, label: 'O375' },
    { element: 'O', fx: 0.802, fy: 0.802, fz: 0.4467, label: 'O376' },
    { element: 'O', fx: 0.698, fy: 0.198, fz: 0.9467, label: 'O377' },
    { element: 'O', fx: 0.698, fy: 0.698, fz: 0.4467, label: 'O378' },
    { element: 'O', fx: 0.198, fy: 0.698, fz: 0.9467, label: 'O379' },
    { element: 'O', fx: 0.198, fy: 0.198, fz: 0.4467, label: 'O380' },
    { element: 'O', fx: 0.052, fy: 0.448, fz: 0.6967, label: 'O381' },
    { element: 'O', fx: 0.052, fy: 0.948, fz: 0.1967, label: 'O382' },
    { element: 'O', fx: 0.552, fy: 0.948, fz: 0.6967, label: 'O383' },
    { element: 'O', fx: 0.552, fy: 0.448, fz: 0.1967, label: 'O384' },
  ],
};

// All-silica MFI (silicalite-1, the parent of ZSM-5). Medium-pore
// 10-ring channels (5.5 Å) — the most important catalytic zeolite
// (FCC, methanol-to-gasoline, xylene isomerization). Pnma
// orthorhombic. 288 atoms in the conventional cell exceeds the
// 200-atom MD cap (no smaller cell available) — visualization-only
// until the cap is raised. Coordinates from IZA-SC CIF.
export const SILICALITE: CrystalState = {
  name: 'Silicalite',
  lattice: { a: 20.09, b: 19.738, c: 13.142, alpha: 90, beta: 90, gamma: 90 },
  spaceGroup: 'P n m a',
  basis: [
    { element: 'Si', fx: 0.4214, fy: 0.0711, fz: 0.6898, label: 'Si1' },
    { element: 'Si', fx: 0.0786, fy: 0.5711, fz: 0.1898, label: 'Si2' },
    { element: 'Si', fx: 0.4214, fy: 0.4289, fz: 0.6898, label: 'Si3' },
    { element: 'Si', fx: 0.0786, fy: 0.9289, fz: 0.1898, label: 'Si4' },
    { element: 'Si', fx: 0.5786, fy: 0.9289, fz: 0.3102, label: 'Si5' },
    { element: 'Si', fx: 0.9214, fy: 0.4289, fz: 0.8102, label: 'Si6' },
    { element: 'Si', fx: 0.5786, fy: 0.5711, fz: 0.3102, label: 'Si7' },
    { element: 'Si', fx: 0.9214, fy: 0.0711, fz: 0.8102, label: 'Si8' },
    { element: 'Si', fx: 0.3259, fy: 0.0336, fz: 0.85, label: 'Si9' },
    { element: 'Si', fx: 0.1741, fy: 0.5336, fz: 0.35, label: 'Si10' },
    { element: 'Si', fx: 0.3259, fy: 0.4664, fz: 0.85, label: 'Si11' },
    { element: 'Si', fx: 0.1741, fy: 0.9664, fz: 0.35, label: 'Si12' },
    { element: 'Si', fx: 0.6741, fy: 0.9664, fz: 0.15, label: 'Si13' },
    { element: 'Si', fx: 0.8259, fy: 0.4664, fz: 0.65, label: 'Si14' },
    { element: 'Si', fx: 0.6741, fy: 0.5336, fz: 0.15, label: 'Si15' },
    { element: 'Si', fx: 0.8259, fy: 0.0336, fz: 0.65, label: 'Si16' },
    { element: 'Si', fx: 0.2792, fy: 0.0536, fz: 0.0655, label: 'Si17' },
    { element: 'Si', fx: 0.2208, fy: 0.5536, fz: 0.5655, label: 'Si18' },
    { element: 'Si', fx: 0.2792, fy: 0.4464, fz: 0.0655, label: 'Si19' },
    { element: 'Si', fx: 0.2208, fy: 0.9464, fz: 0.5655, label: 'Si20' },
    { element: 'Si', fx: 0.7208, fy: 0.9464, fz: 0.9345, label: 'Si21' },
    { element: 'Si', fx: 0.7792, fy: 0.4464, fz: 0.4345, label: 'Si22' },
    { element: 'Si', fx: 0.7208, fy: 0.5536, fz: 0.9345, label: 'Si23' },
    { element: 'Si', fx: 0.7792, fy: 0.0536, fz: 0.4345, label: 'Si24' },
    { element: 'Si', fx: 0.1246, fy: 0.0514, fz: 0.0481, label: 'Si25' },
    { element: 'Si', fx: 0.3754, fy: 0.5514, fz: 0.5481, label: 'Si26' },
    { element: 'Si', fx: 0.1246, fy: 0.4486, fz: 0.0481, label: 'Si27' },
    { element: 'Si', fx: 0.3754, fy: 0.9486, fz: 0.5481, label: 'Si28' },
    { element: 'Si', fx: 0.8754, fy: 0.9486, fz: 0.9519, label: 'Si29' },
    { element: 'Si', fx: 0.6246, fy: 0.4486, fz: 0.4519, label: 'Si30' },
    { element: 'Si', fx: 0.8754, fy: 0.5514, fz: 0.9519, label: 'Si31' },
    { element: 'Si', fx: 0.6246, fy: 0.0514, fz: 0.4519, label: 'Si32' },
    { element: 'Si', fx: 0.0721, fy: 0.036, fz: 0.8233, label: 'Si33' },
    { element: 'Si', fx: 0.4279, fy: 0.536, fz: 0.3233, label: 'Si34' },
    { element: 'Si', fx: 0.0721, fy: 0.464, fz: 0.8233, label: 'Si35' },
    { element: 'Si', fx: 0.4279, fy: 0.964, fz: 0.3233, label: 'Si36' },
    { element: 'Si', fx: 0.9279, fy: 0.964, fz: 0.1767, label: 'Si37' },
    { element: 'Si', fx: 0.5721, fy: 0.464, fz: 0.6767, label: 'Si38' },
    { element: 'Si', fx: 0.9279, fy: 0.536, fz: 0.1767, label: 'Si39' },
    { element: 'Si', fx: 0.5721, fy: 0.036, fz: 0.6767, label: 'Si40' },
    { element: 'Si', fx: 0.2034, fy: 0.0687, fz: 0.7197, label: 'Si41' },
    { element: 'Si', fx: 0.2966, fy: 0.5687, fz: 0.2197, label: 'Si42' },
    { element: 'Si', fx: 0.2034, fy: 0.4313, fz: 0.7197, label: 'Si43' },
    { element: 'Si', fx: 0.2966, fy: 0.9313, fz: 0.2197, label: 'Si44' },
    { element: 'Si', fx: 0.7966, fy: 0.9313, fz: 0.2803, label: 'Si45' },
    { element: 'Si', fx: 0.7034, fy: 0.4313, fz: 0.7803, label: 'Si46' },
    { element: 'Si', fx: 0.7966, fy: 0.5687, fz: 0.2803, label: 'Si47' },
    { element: 'Si', fx: 0.7034, fy: 0.0687, fz: 0.7803, label: 'Si48' },
    { element: 'Si', fx: 0.4195, fy: 0.8274, fz: 0.6805, label: 'Si49' },
    { element: 'Si', fx: 0.0805, fy: 0.3274, fz: 0.1805, label: 'Si50' },
    { element: 'Si', fx: 0.4195, fy: 0.6726, fz: 0.6805, label: 'Si51' },
    { element: 'Si', fx: 0.0805, fy: 0.1726, fz: 0.1805, label: 'Si52' },
    { element: 'Si', fx: 0.5805, fy: 0.1726, fz: 0.3195, label: 'Si53' },
    { element: 'Si', fx: 0.9195, fy: 0.6726, fz: 0.8195, label: 'Si54' },
    { element: 'Si', fx: 0.5805, fy: 0.3274, fz: 0.3195, label: 'Si55' },
    { element: 'Si', fx: 0.9195, fy: 0.8274, fz: 0.8195, label: 'Si56' },
    { element: 'Si', fx: 0.3152, fy: 0.8765, fz: 0.8361, label: 'Si57' },
    { element: 'Si', fx: 0.1848, fy: 0.3765, fz: 0.3361, label: 'Si58' },
    { element: 'Si', fx: 0.3152, fy: 0.6235, fz: 0.8361, label: 'Si59' },
    { element: 'Si', fx: 0.1848, fy: 0.1235, fz: 0.3361, label: 'Si60' },
    { element: 'Si', fx: 0.6848, fy: 0.1235, fz: 0.1639, label: 'Si61' },
    { element: 'Si', fx: 0.8152, fy: 0.6235, fz: 0.6639, label: 'Si62' },
    { element: 'Si', fx: 0.6848, fy: 0.3765, fz: 0.1639, label: 'Si63' },
    { element: 'Si', fx: 0.8152, fy: 0.8765, fz: 0.6639, label: 'Si64' },
    { element: 'Si', fx: 0.2733, fy: 0.8278, fz: 0.0402, label: 'Si65' },
    { element: 'Si', fx: 0.2267, fy: 0.3278, fz: 0.5402, label: 'Si66' },
    { element: 'Si', fx: 0.2733, fy: 0.6722, fz: 0.0402, label: 'Si67' },
    { element: 'Si', fx: 0.2267, fy: 0.1722, fz: 0.5402, label: 'Si68' },
    { element: 'Si', fx: 0.7267, fy: 0.1722, fz: 0.9598, label: 'Si69' },
    { element: 'Si', fx: 0.7733, fy: 0.6722, fz: 0.4598, label: 'Si70' },
    { element: 'Si', fx: 0.7267, fy: 0.3278, fz: 0.9598, label: 'Si71' },
    { element: 'Si', fx: 0.7733, fy: 0.8278, fz: 0.4598, label: 'Si72' },
    { element: 'Si', fx: 0.1185, fy: 0.8279, fz: 0.0183, label: 'Si73' },
    { element: 'Si', fx: 0.3815, fy: 0.3279, fz: 0.5183, label: 'Si74' },
    { element: 'Si', fx: 0.1185, fy: 0.6721, fz: 0.0183, label: 'Si75' },
    { element: 'Si', fx: 0.3815, fy: 0.1721, fz: 0.5183, label: 'Si76' },
    { element: 'Si', fx: 0.8815, fy: 0.1721, fz: 0.9817, label: 'Si77' },
    { element: 'Si', fx: 0.6185, fy: 0.6721, fz: 0.4817, label: 'Si78' },
    { element: 'Si', fx: 0.8815, fy: 0.3279, fz: 0.9817, label: 'Si79' },
    { element: 'Si', fx: 0.6185, fy: 0.8279, fz: 0.4817, label: 'Si80' },
    { element: 'Si', fx: 0.0657, fy: 0.8794, fz: 0.8087, label: 'Si81' },
    { element: 'Si', fx: 0.4343, fy: 0.3794, fz: 0.3087, label: 'Si82' },
    { element: 'Si', fx: 0.0657, fy: 0.6206, fz: 0.8087, label: 'Si83' },
    { element: 'Si', fx: 0.4343, fy: 0.1206, fz: 0.3087, label: 'Si84' },
    { element: 'Si', fx: 0.9343, fy: 0.1206, fz: 0.1913, label: 'Si85' },
    { element: 'Si', fx: 0.5657, fy: 0.6206, fz: 0.6913, label: 'Si86' },
    { element: 'Si', fx: 0.9343, fy: 0.3794, fz: 0.1913, label: 'Si87' },
    { element: 'Si', fx: 0.5657, fy: 0.8794, fz: 0.6913, label: 'Si88' },
    { element: 'Si', fx: 0.1947, fy: 0.8288, fz: 0.7092, label: 'Si89' },
    { element: 'Si', fx: 0.3053, fy: 0.3288, fz: 0.2092, label: 'Si90' },
    { element: 'Si', fx: 0.1947, fy: 0.6712, fz: 0.7092, label: 'Si91' },
    { element: 'Si', fx: 0.3053, fy: 0.1712, fz: 0.2092, label: 'Si92' },
    { element: 'Si', fx: 0.8053, fy: 0.1712, fz: 0.2908, label: 'Si93' },
    { element: 'Si', fx: 0.6947, fy: 0.6712, fz: 0.7908, label: 'Si94' },
    { element: 'Si', fx: 0.8053, fy: 0.3288, fz: 0.2908, label: 'Si95' },
    { element: 'Si', fx: 0.6947, fy: 0.8288, fz: 0.7908, label: 'Si96' },
    { element: 'O', fx: 0.5012, fy: 0.0699, fz: 0.7018, label: 'O1' },
    { element: 'O', fx: 0.9988, fy: 0.5699, fz: 0.2018, label: 'O2' },
    { element: 'O', fx: 0.5012, fy: 0.4301, fz: 0.7018, label: 'O3' },
    { element: 'O', fx: 0.9988, fy: 0.9301, fz: 0.2018, label: 'O4' },
    { element: 'O', fx: 0.4988, fy: 0.9301, fz: 0.2982, label: 'O5' },
    { element: 'O', fx: 0.0012, fy: 0.4301, fz: 0.7982, label: 'O6' },
    { element: 'O', fx: 0.4988, fy: 0.5699, fz: 0.2982, label: 'O7' },
    { element: 'O', fx: 0.0012, fy: 0.0699, fz: 0.7982, label: 'O8' },
    { element: 'O', fx: 0.3875, fy: 0.0743, fz: 0.8008, label: 'O9' },
    { element: 'O', fx: 0.1125, fy: 0.5743, fz: 0.3008, label: 'O10' },
    { element: 'O', fx: 0.3875, fy: 0.4257, fz: 0.8008, label: 'O11' },
    { element: 'O', fx: 0.1125, fy: 0.9257, fz: 0.3008, label: 'O12' },
    { element: 'O', fx: 0.6125, fy: 0.9257, fz: 0.1992, label: 'O13' },
    { element: 'O', fx: 0.8875, fy: 0.4257, fz: 0.6992, label: 'O14' },
    { element: 'O', fx: 0.6125, fy: 0.5743, fz: 0.1992, label: 'O15' },
    { element: 'O', fx: 0.8875, fy: 0.0743, fz: 0.6992, label: 'O16' },
    { element: 'O', fx: 0.3995, fy: 0.1366, fz: 0.6251, label: 'O17' },
    { element: 'O', fx: 0.1005, fy: 0.6366, fz: 0.1251, label: 'O18' },
    { element: 'O', fx: 0.3995, fy: 0.3634, fz: 0.6251, label: 'O19' },
    { element: 'O', fx: 0.1005, fy: 0.8634, fz: 0.1251, label: 'O20' },
    { element: 'O', fx: 0.6005, fy: 0.8634, fz: 0.3749, label: 'O21' },
    { element: 'O', fx: 0.8995, fy: 0.3634, fz: 0.8749, label: 'O22' },
    { element: 'O', fx: 0.6005, fy: 0.6366, fz: 0.3749, label: 'O23' },
    { element: 'O', fx: 0.8995, fy: 0.1366, fz: 0.8749, label: 'O24' },
    { element: 'O', fx: 0.3972, fy: 0.0034, fz: 0.6326, label: 'O25' },
    { element: 'O', fx: 0.1028, fy: 0.5034, fz: 0.1326, label: 'O26' },
    { element: 'O', fx: 0.3972, fy: 0.4966, fz: 0.6326, label: 'O27' },
    { element: 'O', fx: 0.1028, fy: 0.9966, fz: 0.1326, label: 'O28' },
    { element: 'O', fx: 0.6028, fy: 0.9966, fz: 0.3674, label: 'O29' },
    { element: 'O', fx: 0.8972, fy: 0.4966, fz: 0.8674, label: 'O30' },
    { element: 'O', fx: 0.6028, fy: 0.5034, fz: 0.3674, label: 'O31' },
    { element: 'O', fx: 0.8972, fy: 0.0034, fz: 0.8674, label: 'O32' },
    { element: 'O', fx: 0.329, fy: 0.0385, fz: 0.9722, label: 'O33' },
    { element: 'O', fx: 0.171, fy: 0.5385, fz: 0.4722, label: 'O34' },
    { element: 'O', fx: 0.329, fy: 0.4615, fz: 0.9722, label: 'O35' },
    { element: 'O', fx: 0.171, fy: 0.9615, fz: 0.4722, label: 'O36' },
    { element: 'O', fx: 0.671, fy: 0.9615, fz: 0.0278, label: 'O37' },
    { element: 'O', fx: 0.829, fy: 0.4615, fz: 0.5278, label: 'O38' },
    { element: 'O', fx: 0.671, fy: 0.5385, fz: 0.0278, label: 'O39' },
    { element: 'O', fx: 0.829, fy: 0.0385, fz: 0.5278, label: 'O40' },
    { element: 'O', fx: 0.3297, fy: 0.9555, fz: 0.8155, label: 'O41' },
    { element: 'O', fx: 0.1703, fy: 0.4555, fz: 0.3155, label: 'O42' },
    { element: 'O', fx: 0.3297, fy: 0.5445, fz: 0.8155, label: 'O43' },
    { element: 'O', fx: 0.1703, fy: 0.0445, fz: 0.3155, label: 'O44' },
    { element: 'O', fx: 0.6703, fy: 0.0445, fz: 0.1845, label: 'O45' },
    { element: 'O', fx: 0.8297, fy: 0.5445, fz: 0.6845, label: 'O46' },
    { element: 'O', fx: 0.6703, fy: 0.4555, fz: 0.1845, label: 'O47' },
    { element: 'O', fx: 0.8297, fy: 0.9555, fz: 0.6845, label: 'O48' },
    { element: 'O', fx: 0.2571, fy: 0.0663, fz: 0.8106, label: 'O49' },
    { element: 'O', fx: 0.2429, fy: 0.5663, fz: 0.3106, label: 'O50' },
    { element: 'O', fx: 0.2571, fy: 0.4337, fz: 0.8106, label: 'O51' },
    { element: 'O', fx: 0.2429, fy: 0.9337, fz: 0.3106, label: 'O52' },
    { element: 'O', fx: 0.7429, fy: 0.9337, fz: 0.1894, label: 'O53' },
    { element: 'O', fx: 0.7571, fy: 0.4337, fz: 0.6894, label: 'O54' },
    { element: 'O', fx: 0.7429, fy: 0.5663, fz: 0.1894, label: 'O55' },
    { element: 'O', fx: 0.7571, fy: 0.0663, fz: 0.6894, label: 'O56' },
    { element: 'O', fx: 0.291, fy: 0.1296, fz: 0.106, label: 'O57' },
    { element: 'O', fx: 0.209, fy: 0.6296, fz: 0.606, label: 'O58' },
    { element: 'O', fx: 0.291, fy: 0.3704, fz: 0.106, label: 'O59' },
    { element: 'O', fx: 0.209, fy: 0.8704, fz: 0.606, label: 'O60' },
    { element: 'O', fx: 0.709, fy: 0.8704, fz: 0.894, label: 'O61' },
    { element: 'O', fx: 0.791, fy: 0.3704, fz: 0.394, label: 'O62' },
    { element: 'O', fx: 0.709, fy: 0.6296, fz: 0.894, label: 'O63' },
    { element: 'O', fx: 0.791, fy: 0.1296, fz: 0.394, label: 'O64' },
    { element: 'O', fx: 0.2034, fy: 0.0455, fz: 0.0275, label: 'O65' },
    { element: 'O', fx: 0.2966, fy: 0.5455, fz: 0.5275, label: 'O66' },
    { element: 'O', fx: 0.2034, fy: 0.4545, fz: 0.0275, label: 'O67' },
    { element: 'O', fx: 0.2966, fy: 0.9545, fz: 0.5275, label: 'O68' },
    { element: 'O', fx: 0.7966, fy: 0.9545, fz: 0.9725, label: 'O69' },
    { element: 'O', fx: 0.7034, fy: 0.4545, fz: 0.4725, label: 'O70' },
    { element: 'O', fx: 0.7966, fy: 0.5455, fz: 0.9725, label: 'O71' },
    { element: 'O', fx: 0.7034, fy: 0.0455, fz: 0.4725, label: 'O72' },
    { element: 'O', fx: 0.2936, fy: 0.001, fz: 0.1564, label: 'O73' },
    { element: 'O', fx: 0.2064, fy: 0.501, fz: 0.6564, label: 'O74' },
    { element: 'O', fx: 0.2936, fy: 0.499, fz: 0.1564, label: 'O75' },
    { element: 'O', fx: 0.2064, fy: 0.999, fz: 0.6564, label: 'O76' },
    { element: 'O', fx: 0.7064, fy: 0.999, fz: 0.8436, label: 'O77' },
    { element: 'O', fx: 0.7936, fy: 0.499, fz: 0.3436, label: 'O78' },
    { element: 'O', fx: 0.7064, fy: 0.501, fz: 0.8436, label: 'O79' },
    { element: 'O', fx: 0.7936, fy: 0.001, fz: 0.3436, label: 'O80' },
    { element: 'O', fx: 0.1075, fy: 0.1265, fz: 0.0883, label: 'O81' },
    { element: 'O', fx: 0.3925, fy: 0.6265, fz: 0.5883, label: 'O82' },
    { element: 'O', fx: 0.1075, fy: 0.3735, fz: 0.0883, label: 'O83' },
    { element: 'O', fx: 0.3925, fy: 0.8735, fz: 0.5883, label: 'O84' },
    { element: 'O', fx: 0.8925, fy: 0.8735, fz: 0.9117, label: 'O85' },
    { element: 'O', fx: 0.6075, fy: 0.3735, fz: 0.4117, label: 'O86' },
    { element: 'O', fx: 0.8925, fy: 0.6265, fz: 0.9117, label: 'O87' },
    { element: 'O', fx: 0.6075, fy: 0.1265, fz: 0.4117, label: 'O88' },
    { element: 'O', fx: 0.0846, fy: 0.037, fz: 0.9443, label: 'O89' },
    { element: 'O', fx: 0.4154, fy: 0.537, fz: 0.4443, label: 'O90' },
    { element: 'O', fx: 0.0846, fy: 0.463, fz: 0.9443, label: 'O91' },
    { element: 'O', fx: 0.4154, fy: 0.963, fz: 0.4443, label: 'O92' },
    { element: 'O', fx: 0.9154, fy: 0.963, fz: 0.0557, label: 'O93' },
    { element: 'O', fx: 0.5846, fy: 0.463, fz: 0.5557, label: 'O94' },
    { element: 'O', fx: 0.9154, fy: 0.537, fz: 0.0557, label: 'O95' },
    { element: 'O', fx: 0.5846, fy: 0.037, fz: 0.5557, label: 'O96' },
    { element: 'O', fx: 0.1301, fy: 0.0781, fz: 0.767, label: 'O97' },
    { element: 'O', fx: 0.3699, fy: 0.5781, fz: 0.267, label: 'O98' },
    { element: 'O', fx: 0.1301, fy: 0.4219, fz: 0.767, label: 'O99' },
    { element: 'O', fx: 0.3699, fy: 0.9219, fz: 0.267, label: 'O100' },
    { element: 'O', fx: 0.8699, fy: 0.9219, fz: 0.233, label: 'O101' },
    { element: 'O', fx: 0.6301, fy: 0.4219, fz: 0.733, label: 'O102' },
    { element: 'O', fx: 0.8699, fy: 0.5781, fz: 0.233, label: 'O103' },
    { element: 'O', fx: 0.6301, fy: 0.0781, fz: 0.733, label: 'O104' },
    { element: 'O', fx: 0.0728, fy: 0.9589, fz: 0.7832, label: 'O105' },
    { element: 'O', fx: 0.4272, fy: 0.4589, fz: 0.2832, label: 'O106' },
    { element: 'O', fx: 0.0728, fy: 0.5411, fz: 0.7832, label: 'O107' },
    { element: 'O', fx: 0.4272, fy: 0.0411, fz: 0.2832, label: 'O108' },
    { element: 'O', fx: 0.9272, fy: 0.0411, fz: 0.2168, label: 'O109' },
    { element: 'O', fx: 0.5728, fy: 0.5411, fz: 0.7168, label: 'O110' },
    { element: 'O', fx: 0.9272, fy: 0.4589, fz: 0.2168, label: 'O111' },
    { element: 'O', fx: 0.5728, fy: 0.9589, fz: 0.7168, label: 'O112' },
    { element: 'O', fx: 0.2201, fy: 0.1313, fz: 0.6456, label: 'O113' },
    { element: 'O', fx: 0.2799, fy: 0.6313, fz: 0.1456, label: 'O114' },
    { element: 'O', fx: 0.2201, fy: 0.3687, fz: 0.6456, label: 'O115' },
    { element: 'O', fx: 0.2799, fy: 0.8687, fz: 0.1456, label: 'O116' },
    { element: 'O', fx: 0.7799, fy: 0.8687, fz: 0.3544, label: 'O117' },
    { element: 'O', fx: 0.7201, fy: 0.3687, fz: 0.8544, label: 'O118' },
    { element: 'O', fx: 0.7799, fy: 0.6313, fz: 0.3544, label: 'O119' },
    { element: 'O', fx: 0.7201, fy: 0.1313, fz: 0.8544, label: 'O120' },
    { element: 'O', fx: 0.4911, fy: 0.8548, fz: 0.7169, label: 'O121' },
    { element: 'O', fx: 0.0089, fy: 0.3548, fz: 0.2169, label: 'O122' },
    { element: 'O', fx: 0.4911, fy: 0.6452, fz: 0.7169, label: 'O123' },
    { element: 'O', fx: 0.0089, fy: 0.1452, fz: 0.2169, label: 'O124' },
    { element: 'O', fx: 0.5089, fy: 0.1452, fz: 0.2831, label: 'O125' },
    { element: 'O', fx: 0.9911, fy: 0.6452, fz: 0.7831, label: 'O126' },
    { element: 'O', fx: 0.5089, fy: 0.3548, fz: 0.2831, label: 'O127' },
    { element: 'O', fx: 0.9911, fy: 0.8548, fz: 0.7831, label: 'O128' },
    { element: 'O', fx: 0.3681, fy: 0.8311, fz: 0.7743, label: 'O129' },
    { element: 'O', fx: 0.1319, fy: 0.3311, fz: 0.2743, label: 'O130' },
    { element: 'O', fx: 0.3681, fy: 0.6689, fz: 0.7743, label: 'O131' },
    { element: 'O', fx: 0.1319, fy: 0.1689, fz: 0.2743, label: 'O132' },
    { element: 'O', fx: 0.6319, fy: 0.1689, fz: 0.2257, label: 'O133' },
    { element: 'O', fx: 0.8681, fy: 0.6689, fz: 0.7257, label: 'O134' },
    { element: 'O', fx: 0.6319, fy: 0.3311, fz: 0.2257, label: 'O135' },
    { element: 'O', fx: 0.8681, fy: 0.8311, fz: 0.7257, label: 'O136' },
    { element: 'O', fx: 0.4263, fy: 0.75, fz: 0.6431, label: 'O137' },
    { element: 'O', fx: 0.0737, fy: 0.25, fz: 0.1431, label: 'O138' },
    { element: 'O', fx: 0.5737, fy: 0.25, fz: 0.3569, label: 'O139' },
    { element: 'O', fx: 0.9263, fy: 0.75, fz: 0.8569, label: 'O140' },
    { element: 'O', fx: 0.3217, fy: 0.8611, fz: 0.9561, label: 'O141' },
    { element: 'O', fx: 0.1783, fy: 0.3611, fz: 0.4561, label: 'O142' },
    { element: 'O', fx: 0.3217, fy: 0.6389, fz: 0.9561, label: 'O143' },
    { element: 'O', fx: 0.1783, fy: 0.1389, fz: 0.4561, label: 'O144' },
    { element: 'O', fx: 0.6783, fy: 0.1389, fz: 0.0439, label: 'O145' },
    { element: 'O', fx: 0.8217, fy: 0.6389, fz: 0.5439, label: 'O146' },
    { element: 'O', fx: 0.6783, fy: 0.3611, fz: 0.0439, label: 'O147' },
    { element: 'O', fx: 0.8217, fy: 0.8611, fz: 0.5439, label: 'O148' },
    { element: 'O', fx: 0.241, fy: 0.8582, fz: 0.799, label: 'O149' },
    { element: 'O', fx: 0.259, fy: 0.3582, fz: 0.299, label: 'O150' },
    { element: 'O', fx: 0.241, fy: 0.6418, fz: 0.799, label: 'O151' },
    { element: 'O', fx: 0.259, fy: 0.1418, fz: 0.299, label: 'O152' },
    { element: 'O', fx: 0.759, fy: 0.1418, fz: 0.201, label: 'O153' },
    { element: 'O', fx: 0.741, fy: 0.6418, fz: 0.701, label: 'O154' },
    { element: 'O', fx: 0.759, fy: 0.3582, fz: 0.201, label: 'O155' },
    { element: 'O', fx: 0.741, fy: 0.8582, fz: 0.701, label: 'O156' },
    { element: 'O', fx: 0.2943, fy: 0.75, fz: 0.0579, label: 'O157' },
    { element: 'O', fx: 0.2057, fy: 0.25, fz: 0.5579, label: 'O158' },
    { element: 'O', fx: 0.7057, fy: 0.25, fz: 0.9421, label: 'O159' },
    { element: 'O', fx: 0.7943, fy: 0.75, fz: 0.4421, label: 'O160' },
    { element: 'O', fx: 0.1976, fy: 0.8313, fz: 0.0003, label: 'O161' },
    { element: 'O', fx: 0.3024, fy: 0.3313, fz: 0.5003, label: 'O162' },
    { element: 'O', fx: 0.1976, fy: 0.6687, fz: 0.0003, label: 'O163' },
    { element: 'O', fx: 0.3024, fy: 0.1687, fz: 0.5003, label: 'O164' },
    { element: 'O', fx: 0.8024, fy: 0.1687, fz: 0.9997, label: 'O165' },
    { element: 'O', fx: 0.6976, fy: 0.6687, fz: 0.4997, label: 'O166' },
    { element: 'O', fx: 0.8024, fy: 0.3313, fz: 0.9997, label: 'O167' },
    { element: 'O', fx: 0.6976, fy: 0.8313, fz: 0.4997, label: 'O168' },
    { element: 'O', fx: 0.0948, fy: 0.75, fz: 0.0205, label: 'O169' },
    { element: 'O', fx: 0.4052, fy: 0.25, fz: 0.5205, label: 'O170' },
    { element: 'O', fx: 0.9052, fy: 0.25, fz: 0.9795, label: 'O171' },
    { element: 'O', fx: 0.5948, fy: 0.75, fz: 0.4795, label: 'O172' },
    { element: 'O', fx: 0.0809, fy: 0.867, fz: 0.9275, label: 'O173' },
    { element: 'O', fx: 0.4191, fy: 0.367, fz: 0.4275, label: 'O174' },
    { element: 'O', fx: 0.0809, fy: 0.633, fz: 0.9275, label: 'O175' },
    { element: 'O', fx: 0.4191, fy: 0.133, fz: 0.4275, label: 'O176' },
    { element: 'O', fx: 0.9191, fy: 0.133, fz: 0.0725, label: 'O177' },
    { element: 'O', fx: 0.5809, fy: 0.633, fz: 0.5725, label: 'O178' },
    { element: 'O', fx: 0.9191, fy: 0.367, fz: 0.0725, label: 'O179' },
    { element: 'O', fx: 0.5809, fy: 0.867, fz: 0.5725, label: 'O180' },
    { element: 'O', fx: 0.1177, fy: 0.837, fz: 0.7406, label: 'O181' },
    { element: 'O', fx: 0.3823, fy: 0.337, fz: 0.2406, label: 'O182' },
    { element: 'O', fx: 0.1177, fy: 0.663, fz: 0.7406, label: 'O183' },
    { element: 'O', fx: 0.3823, fy: 0.163, fz: 0.2406, label: 'O184' },
    { element: 'O', fx: 0.8823, fy: 0.163, fz: 0.2594, label: 'O185' },
    { element: 'O', fx: 0.6177, fy: 0.663, fz: 0.7594, label: 'O186' },
    { element: 'O', fx: 0.8823, fy: 0.337, fz: 0.2594, label: 'O187' },
    { element: 'O', fx: 0.6177, fy: 0.837, fz: 0.7594, label: 'O188' },
    { element: 'O', fx: 0.2116, fy: 0.75, fz: 0.6913, label: 'O189' },
    { element: 'O', fx: 0.2884, fy: 0.25, fz: 0.1913, label: 'O190' },
    { element: 'O', fx: 0.7884, fy: 0.25, fz: 0.3087, label: 'O191' },
    { element: 'O', fx: 0.7116, fy: 0.75, fz: 0.8087, label: 'O192' },
  ],
};
